// assignment dropdown actions
export const FETCH_APPRAISAL_TYPE_OPTIONS_FOR_APPRAISAL_START =
  'FETCH_APPRAISAL_TYPE_OPTIONS_FOR_APPRAISAL_START'
export const FETCH_APPRAISAL_TYPE_OPTIONS_FOR_APPRAISAL_SUCCESS =
  'FETCH_APPRAISAL_TYPE_OPTIONS_FOR_APPRAISAL_SUCCESS'
export const FETCH_APPRAISAL_TYPE_OPTIONS_FOR_APPRAISAL_FAILED =
  'FETCH_APPRAISAL_TYPE_OPTIONS_FOR_APPRAISAL_FAILED'

export const FETCH_APPRAISAL_STATUS_OPTIONS_FOR_APPRAISAL_START =
  'FETCH_APPRAISAL_STATUS_OPTIONS_FOR_APPRAISAL_START'
export const FETCH_APPRAISAL_STATUS_OPTIONS_FOR_APPRAISAL_SUCCESS =
  'FETCH_APPRAISAL_STATUS_OPTIONS_FOR_APPRAISAL_SUCCESS'
export const FETCH_APPRAISAL_STATUS_OPTIONS_FOR_APPRAISAL_FAILED =
  'FETCH_APPRAISAL_STATUS_OPTIONS_FOR_APPRAISAL_FAILED'

export const FETCH_ASSIGNMENT_STATUS_OPTIONS_FOR_APPRAISAL_START =
  'FETCH_ASSIGNMENT_STATUS_OPTIONS_FOR_APPRAISAL_START'
export const FETCH_ASSIGNMENT_STATUS_OPTIONS_FOR_APPRAISAL_SUCCESS =
  'FETCH_ASSIGNMENT_STATUS_OPTIONS_FOR_APPRAISAL_SUCCESS'
export const FETCH_ASSIGNMENT_STATUS_OPTIONS_FOR_APPRAISAL_FAILED =
  'FETCH_ASSIGNMENT_STATUS_OPTIONS_FOR_APPRAISAL_FAILED'

export const FETCH_RESPONSIBLE_OPTIONS_FOR_APPRAISAL_START =
  'FETCH_RESPONSIBLE_OPTIONS_FOR_APPRAISAL_START'
export const FETCH_RESPONSIBLE_OPTIONS_FOR_APPRAISAL_SUCCESS =
  'FETCH_RESPONSIBLE_OPTIONS_FOR_APPRAISAL_SUCCESS'
export const FETCH_RESPONSIBLE_OPTIONS_FOR_APPRAISAL_FAILED =
  'FETCH_RESPONSIBLE_OPTIONS_FOR_APPRAISAL_FAILED'

export const FETCH_COMPANY_OPTIONS_FOR_APPRAISAL_START = 'FETCH_COMPANY_OPTIONS_FOR_APPRAISAL_START'
export const FETCH_COMPANY_OPTIONS_FOR_APPRAISAL_SUCCESS =
  'FETCH_COMPANY_OPTIONS_FOR_APPRAISAL_SUCCESS'
export const FETCH_COMPANY_OPTIONS_FOR_APPRAISAL_FAILED =
  'FETCH_COMPANY_OPTIONS_FOR_APPRAISAL_FAILED'

export const FETCH_STRUCTURE_OPTIONS_FOR_APPRAISAL_START =
  'FETCH_STRUCTURE_OPTIONS_FOR_APPRAISAL_START'
export const FETCH_STRUCTURE_OPTIONS_FOR_APPRAISAL_SUCCESS =
  'FETCH_STRUCTURE_OPTIONS_FOR_APPRAISAL_SUCCESS'
export const FETCH_STRUCTURE_OPTIONS_FOR_APPRAISAL_FAILED =
  'FETCH_STRUCTURE_OPTIONS_FOR_APPRAISAL_FAILED'

export const FETCH_LEVEL_OPTIONS_FOR_APPRAISAL_START = 'FETCH_LEVEL_OPTIONS_FOR_APPRAISAL_START'
export const FETCH_LEVEL_OPTIONS_FOR_APPRAISAL_SUCCESS = 'FETCH_LEVEL_OPTIONS_FOR_APPRAISAL_SUCCESS'
export const FETCH_LEVEL_OPTIONS_FOR_APPRAISAL_FAILED = 'FETCH_LEVEL_OPTIONS_FOR_APPRAISAL_FAILED'

export const FETCH_LEVEL_GROUP_OPTIONS_FOR_APPRAISAL_START =
  'FETCH_LEVEL_GROUP_OPTIONS_FOR_APPRAISAL_START'
export const FETCH_LEVEL_GROUP_OPTIONS_FOR_APPRAISAL_SUCCESS =
  'FETCH_LEVEL_GROUP_OPTIONS_FOR_APPRAISAL_SUCCESS'
export const FETCH_LEVEL_GROUP_OPTIONS_FOR_APPRAISAL_FAILED =
  'FETCH_LEVEL_GROUP_OPTIONS_FOR_APPRAISAL_FAILED'

export const FETCH_ORGANIZATION_OPTIONS_FOR_APPRAISAL_START =
  'FETCH_ORGANIZATION_OPTIONS_FOR_APPRAISAL_START'
export const FETCH_ORGANIZATION_OPTIONS_FOR_APPRAISAL_SUCCESS =
  'FETCH_ORGANIZATION_OPTIONS_FOR_APPRAISAL_SUCCESS'
export const FETCH_ORGANIZATION_OPTIONS_FOR_APPRAISAL_FAILED =
  'FETCH_ORGANIZATION_OPTIONS_FOR_APPRAISAL_FAILED'

export const FETCH_FORCED_ORGANIZATION_OPTIONS_FOR_APPRAISAL_START =
  'FETCH_FORCED_ORGANIZATION_OPTIONS_FOR_APPRAISAL_START'
export const FETCH_FORCED_ORGANIZATION_OPTIONS_FOR_APPRAISAL_SUCCESS =
  'FETCH_FORCED_ORGANIZATION_OPTIONS_FOR_APPRAISAL_SUCCESS'
export const FETCH_FORCED_ORGANIZATION_OPTIONS_FOR_APPRAISAL_FAILED =
  'FETCH_FORCED_ORGANIZATION_OPTIONS_FOR_APPRAISAL_FAILED'

export const FETCH_POSITION_OPTIONS_FOR_APPRAISAL_START =
  'FETCH_POSITION_OPTIONS_FOR_APPRAISAL_START'
export const FETCH_POSITION_OPTIONS_FOR_APPRAISAL_SUCCESS =
  'FETCH_POSITION_OPTIONS_FOR_APPRAISAL_SUCCESS'
export const FETCH_POSITION_OPTIONS_FOR_APPRAISAL_FAILED =
  'FETCH_POSITION_OPTIONS_FOR_APPRAISAL_FAILED'

export const FETCH_EMPLOYEE_OPTIONS_FOR_APPRAISAL_START =
  'FETCH_EMPLOYEE_OPTIONS_FOR_APPRAISAL_START'
export const FETCH_EMPLOYEE_OPTIONS_FOR_APPRAISAL_SUCCESS =
  'FETCH_EMPLOYEE_OPTIONS_FOR_APPRAISAL_SUCCESS'
export const FETCH_EMPLOYEE_OPTIONS_FOR_APPRAISAL_FAILED =
  'FETCH_EMPLOYEE_OPTIONS_FOR_APPRAISAL_FAILED'

export const FETCH_FORM_OPTIONS_FOR_APPRAISAL_START = 'FETCH_FORM_OPTIONS_FOR_APPRAISAL_START'
export const FETCH_FORM_OPTIONS_FOR_APPRAISAL_SUCCESS = 'FETCH_FORM_OPTIONS_FOR_APPRAISAL_SUCCESS'
export const FETCH_FORM_OPTIONS_FOR_APPRAISAL_FAILED = 'FETCH_FORM_OPTIONS_FOR_APPRAISAL_FAILED'

export const FETCH_CRITERIA_OPTIONS_FOR_APPRAISAL_START =
  'FETCH_CRITERIA_OPTIONS_FOR_APPRAISAL_START'
export const FETCH_CRITERIA_OPTIONS_FOR_APPRAISAL_SUCCESS =
  'FETCH_CRITERIA_OPTIONS_FOR_APPRAISAL_SUCCESS'
export const FETCH_CRITERIA_OPTIONS_FOR_APPRAISAL_FAILED =
  'FETCH_CRITERIA_OPTIONS_FOR_APPRAISAL_FAILED'

// dropdown option actions
export const FETCH_EMPLOYEE_POSITIONS_START = 'FETCH_EMPLOYEE_POSITIONS_START'
export const FETCH_EMPLOYEE_POSITIONS_SUCCESS = 'FETCH_EMPLOYEE_POSITIONS_SUCCESS'
export const FETCH_EMPLOYEE_POSITIONS_FAILED = 'FETCH_EMPLOYEE_POSITIONS_FAILED'

export const FETCH_SELF_POSITION_START = 'FETCH_SELF_POSITION_START'
export const FETCH_SELF_POSITION_SUCCESS = 'FETCH_SELF_POSITION_SUCCESS'
export const FETCH_SELF_POSITION_FAILED = 'FETCH_SELF_POSITION_FAILED'

export const FETCH_COMPETENCY_SCORE_OPTIONS_START = 'FETCH_COMPETENCY_SCORE_OPTIONS_START'
export const FETCH_COMPETENCY_SCORE_OPTIONS_SUCCESS = 'FETCH_COMPETENCY_SCORE_OPTIONS_SUCCESS'
export const FETCH_COMPETENCY_SCORE_OPTIONS_FAILED = 'FETCH_COMPETENCY_SCORE_OPTIONS_FAILED'

export const FETCH_COMPETENCY_SCORE_GROUP_OPTIONS_START =
  'FETCH_COMPETENCY_SCORE_GROUP_OPTIONS_START'
export const FETCH_COMPETENCY_SCORE_GROUP_OPTIONS_SUCCESS =
  'FETCH_COMPETENCY_SCORE_GROUP_OPTIONS_SUCCESS'
export const FETCH_COMPETENCY_SCORE_GROUP_OPTIONS_FAILED =
  'FETCH_COMPETENCY_SCORE_GROUP_OPTIONS_FAILED'

export const FETCH_POSITION_GROUP_LEVEL_OPTIONS_START = 'FETCH_POSITION_GROUP_LEVEL_OPTIONS_START'
export const FETCH_POSITION_GROUP_LEVEL_OPTIONS_SUCCESS =
  'FETCH_POSITION_GROUP_LEVEL_OPTIONS_SUCCESS'
export const FETCH_POSITION_GROUP_LEVEL_OPTIONS_FAILED = 'FETCH_POSITION_GROUP_LEVEL_OPTIONS_FAILED'

export const FETCH_FREQUENCY_TYPE_OPTIONS_START = 'FETCH_FREQUENCY_TYPE_OPTIONS_START'
export const FETCH_FREQUENCY_TYPE_OPTIONS_SUCCESS = 'FETCH_FREQUENCY_TYPE_OPTIONS_SUCCESS'
export const FETCH_FREQUENCY_TYPE_OPTIONS_FAILED = 'FETCH_FREQUENCY_TYPE_OPTIONS_FAILED'

export const FETCH_EMPLOYEE_TYPE_OPTIONS_START = 'FETCH_EMPLOYEE_TYPE_OPTIONS_START'
export const FETCH_EMPLOYEE_TYPE_OPTIONS_SUCCESS = 'FETCH_EMPLOYEE_TYPE_OPTIONS_SUCCESS'
export const FETCH_EMPLOYEE_TYPE_OPTIONS_FAILED = 'FETCH_EMPLOYEE_TYPE_OPTIONS_FAILED'

export const FETCH_ASSESSOR_GROUP_OPTIONS_START = 'FETCH_ACCESSOR_GROUP_OPTIONS_START'
export const FETCH_ASSESSOR_GROUP_OPTIONS_SUCCESS = 'FETCH_ACCESSOR_GROUP_OPTIONS_SUCCESS'
export const FETCH_ASSESSOR_GROUP_OPTIONS_FAILED = 'FETCH_ACCESSOR_GROUP_OPTIONS_FAILED'

export const FETCH_CRITERIA_OPTIONS_START = 'FETCH_CRITERIA_OPTIONS_START'
export const FETCH_CRITERIA_OPTIONS_SUCCESS = 'FETCH_CRITERIA_OPTIONS_SUCCESS'
export const FETCH_CRITERIA_OPTIONS_FAILED = 'FETCH_CRITERIA_OPTIONS_FAILED'

export const FETCH_EMPLOYEE_OPTIONS_START = 'FETCH_EMPLOYEE_OPTIONS_START'
export const FETCH_EMPLOYEE_OPTIONS_SUCCESS = 'FETCH_EMPLOYEE_OPTIONS_SUCCESS'
export const FETCH_EMPLOYEE_OPTIONS_FAILED = 'FETCH_EMPLOYEE_OPTIONS_FAILED'

export const FETCH_ACCESS_TYPE_OPTIONS_START = 'FETCH_ACCESS_TYPE_OPTIONS_START'
export const FETCH_ACCESS_TYPE_OPTIONS_SUCCESS = 'FETCH_ACCESS_TYPE_OPTIONS_SUCCESS'
export const FETCH_ACCESS_TYPE_OPTIONS_FAILED = 'FETCH_ACCESS_TYPE_OPTIONS_FAILED'

export const FETCH_APPRAISAL_ITEM_OPTIONS_START = 'FETCH_APPRAISAL_ITEM_OPTIONS_START'
export const FETCH_APPRAISAL_ITEM_OPTIONS_SUCCESS = 'FETCH_APPRAISAL_ITEM_OPTIONS_SUCCESS'
export const FETCH_APPRAISAL_ITEM_OPTIONS_FAILED = 'FETCH_APPRAISAL_ITEM_OPTIONS_FAILED'

export const FETCH_KPI_TYPE_OPTIONS_START = 'FETCH_KPI_TYPE_OPTIONS_START'
export const FETCH_KPI_TYPE_OPTIONS_SUCCESS = 'FETCH_KPI_TYPE_OPTIONS_SUCCESS'
export const FETCH_KPI_TYPE_OPTIONS_FAILED = 'FETCH_KPI_TYPE_OPTIONS_FAILED'

export const FETCH_PARENT_KPI_OPTIONS_START = 'FETCH_PARENT_KPI_OPTIONS_START'
export const FETCH_PARENT_KPI_OPTIONS_SUCCESS = 'FETCH_PARENT_KPI_OPTIONS_SUCCESS'
export const FETCH_PARENT_KPI_OPTIONS_FAILED = 'FETCH_PARENT_KPI_OPTIONS_FAILED'

export const FETCH_UOM_OPTIONS_START = 'FETCH_UOM_OPTIONS_START'
export const FETCH_UOM_OPTIONS_SUCCESS = 'FETCH_UOM_OPTIONS_SUCCESS'
export const FETCH_UOM_OPTIONS_FAILED = 'FETCH_UOM_OPTIONS_FAILED'

export const FETCH_PERSPECTIVE_OPTIONS_START = 'FETCH_PERSPECTIVE_OPTIONS_START'
export const FETCH_PERSPECTIVE_OPTIONS_SUCCESS = 'FETCH_PERSPECTIVE_OPTIONS_SUCCESS'
export const FETCH_PERSPECTIVE_OPTIONS_FAILED = 'FETCH_PERSPECTIVE_OPTIONS_FAILED'

export const FETCH_VALUE_TYPE_OPTIONS_START = 'FETCH_VALUE_TYPE_OPTIONS_START'
export const FETCH_VALUE_TYPE_OPTIONS_SUCCESS = 'FETCH_VALUE_TYPE_OPTIONS_SUCCESS'
export const FETCH_VALUE_TYPE_OPTIONS_FAILED = 'FETCH_VALUE_TYPE_OPTIONS_FAILED'

export const FETCH_FUNCTION_TYPE_OPTIONS_START = 'FETCH_FUNCTION_TYPE_OPTIONS_START'
export const FETCH_FUNCTION_TYPE_OPTIONS_SUCCESS = 'FETCH_FUNCTION_TYPE_OPTIONS_SUCCESS'
export const FETCH_FUNCTION_TYPE_OPTIONS_FAILED = 'FETCH_FUNCTION_TYPE_OPTIONS_FAILED'

export const FETCH_COMPETENCY_TYPE_OPTIONS_START = 'FETCH_COMPETENCY_TYPE_OPTIONS_START'
export const FETCH_COMPETENCY_TYPE_OPTIONS_SUCCESS = 'FETCH_COMPETENCY_TYPE_OPTIONS_SUCCESS'
export const FETCH_COMPETENCY_TYPE_OPTIONS_FAILED = 'FETCH_COMPETENCY_TYPE_OPTIONS_FAILED'

export const FETCH_TARGET_SCORE_OPTIONS_START = 'FETCH_TARGET_SCORE_OPTIONS_START'
export const FETCH_TARGET_SCORE_OPTIONS_SUCCESS = 'FETCH_TARGET_SCORE_OPTIONS_SUCCESS'
export const FETCH_TARGET_SCORE_OPTIONS_FAILED = 'FETCH_TARGET_SCORE_OPTIONS_FAILED'

export const FETCH_ROLE_OPTIONS_START = 'FETCH_ROLE_OPTIONS_START'
export const FETCH_ROLE_OPTIONS_SUCCESS = 'FETCH_ROLE_OPTIONS_SUCCESS'
export const FETCH_ROLE_OPTIONS_FAILED = 'FETCH_ROLE_OPTIONS_FAILED'

export const FETCH_STRUCTURE_TYPE_OPTIONS_START = 'FETCH_STRUCTURE_TYPE_OPTIONS_START'
export const FETCH_STRUCTURE_TYPE_OPTIONS_SUCCESS = 'FETCH_STRUCTURE_TYPE_OPTIONS_SUCCESS'
export const FETCH_STRUCTURE_TYPE_OPTIONS_FAILED = 'FETCH_STRUCTURE_TYPE_OPTIONS_FAILED'

export const FETCH_APPRAISAL_YEAR_OPTIONS_START = 'FETCH_APPRAISAL_YEAR_OPTIONS_START'
export const FETCH_APPRAISAL_YEAR_OPTIONS_SUCCESS = 'FETCH_APPRAISAL_YEAR_OPTIONS_SUCCESS'
export const FETCH_APPRAISAL_YEAR_OPTIONS_FAILED = 'FETCH_APPRAISAL_YEAR_OPTIONS_FAILED'

export const FETCH_APPRAISAL_TYPE_OPTIONS_START = 'FETCH_APPRAISAL_TYPE_OPTIONS_START'
export const FETCH_APPRAISAL_TYPE_OPTIONS_SUCCESS = 'FETCH_APPRAISAL_TYPE_OPTIONS_SUCCESS'
export const FETCH_APPRAISAL_TYPE_OPTIONS_FAILED = 'FETCH_APPRAISAL_TYPE_OPTIONS_FAILED'

export const FETCH_APPRAISAL_STRUCTURE_OPTIONS_START = 'FETCH_APPRAISAL_STRUCTURE_OPTIONS_START'
export const FETCH_APPRAISAL_STRUCTURE_OPTIONS_SUCCESS = 'FETCH_APPRAISAL_STRUCTURE_OPTIONS_SUCCESS'
export const FETCH_APPRAISAL_STRUCTURE_OPTIONS_FAILED = 'FETCH_APPRAISAL_STRUCTURE_OPTIONS_FAILED'

export const FETCH_PARENT_LEVEL_OPTIONS_START = 'FETCH_PARENT_LEVEL_OPTIONS_START'
export const FETCH_PARENT_LEVEL_OPTIONS_SUCCESS = 'FETCH_PARENT_LEVEL_OPTIONS_SUCCESS'
export const FETCH_PARENT_LEVEL_OPTIONS_FAILED = 'FETCH_PARENT_LEVEL_OPTIONS_FAILED'

export const FETCH_PARENT_COMPANY_OPTIONS_START = 'FETCH_PARENT_COMPANY_OPTIONS_START'
export const FETCH_PARENT_COMPANY_OPTIONS_SUCCESS = 'FETCH_PARENT_COMPANY_OPTIONS_SUCCESS'
export const FETCH_PARENT_COMPANY_OPTIONS_FAILED = 'FETCH_PARENT_COMPANY_OPTIONS_FAILED'

export const FETCH_PASSWORD_POLICY_OPTIONS_START = 'FETCH_PASSWORD_POLICY_OPTIONS_START'
export const FETCH_PASSWORD_POLICY_OPTIONS_SUCCESS = 'FETCH_PASSWORD_POLICY_OPTIONS_SUCCESS'
export const FETCH_PASSWORD_POLICY_OPTIONS_FAILED = 'FETCH_PASSWORD_POLICY_OPTIONS_FAILED'

export const FETCH_LDAP_SERVER_OPTIONS_START = 'FETCH_LDAP_SERVER_OPTIONS_START'
export const FETCH_LDAP_SERVER_OPTIONS_SUCCESS = 'FETCH_LDAP_SERVER_OPTIONS_SUCCESS'
export const FETCH_LDAP_SERVER_OPTIONS_FAILED = 'FETCH_LDAP_SERVER_OPTIONS_FAILED'

export const FETCH_EMAIL_SERVER_OPTIONS_START = 'FETCH_EMAIL_SERVER_OPTIONS_START'
export const FETCH_EMAIL_SERVER_OPTIONS_SUCCESS = 'FETCH_EMAIL_SERVER_OPTIONS_SUCCESS'
export const FETCH_EMAIL_SERVER_OPTIONS_FAILED = 'FETCH_EMAIL_SERVER_OPTIONS_FAILED'

export const FETCH_COMPANY_OPTIONS_START = 'FETCH_COMPANY_OPTIONS_START'
export const FETCH_COMPANY_OPTIONS_SUCCESS = 'FETCH_COMPANY_OPTIONS_SUCCESS'
export const FETCH_COMPANY_OPTIONS_FAILED = 'FETCH_COMPANY_OPTIONS_FAILED'

export const FETCH_EMPLOYEE_LEVEL_OPTIONS_START = 'FETCH_EMPLOYEE_LEVEL_OPTIONS_START'
export const FETCH_EMPLOYEE_LEVEL_OPTIONS_SUCCESS = 'FETCH_EMPLOYEE_LEVEL_OPTIONS_SUCCESS'
export const FETCH_EMPLOYEE_LEVEL_OPTIONS_FAILED = 'FETCH_EMPLOYEE_LEVEL_OPTIONS_FAILED'

export const FETCH_ORGANIZATION_LEVEL_OPTIONS_START = 'FETCH_ORGANIZATION_LEVEL_OPTIONS_START'
export const FETCH_ORGANIZATION_LEVEL_OPTIONS_SUCCESS = 'FETCH_ORGANIZATION_LEVEL_OPTIONS_SUCCESS'
export const FETCH_ORGANIZATION_LEVEL_OPTIONS_FAILED = 'FETCH_ORGANIZATION_LEVEL_OPTIONS_FAILED'

export const FETCH_ORGANIZATION_OPTIONS_START = 'FETCH_ORGANIZATION_OPTIONS_START'
export const FETCH_ORGANIZATION_OPTIONS_SUCCESS = 'FETCH_ORGANIZATION_OPTIONS_SUCCESS'
export const FETCH_ORGANIZATION_OPTIONS_FAILED = 'FETCH_ORGANIZATION_OPTIONS_FAILED'

export const FETCH_POSITION_OPTIONS_START = 'FETCH_POSITION_OPTIONS_START'
export const FETCH_POSITION_OPTIONS_SUCCESS = 'FETCH_POSITION_OPTIONS_SUCCESS'
export const FETCH_POSITION_OPTIONS_FAILED = 'FETCH_POSITION_OPTIONS_FAILED'

export const FETCH_POSITION_GROUP_OPTIONS_START = 'FETCH_POSITION_GROUP_OPTIONS_START'
export const FETCH_POSITION_GROUP_OPTIONS_SUCCESS = 'FETCH_POSITION_GROUP_OPTIONS_SUCCESS'
export const FETCH_POSITION_GROUP_OPTIONS_FAILED = 'FETCH_POSITION_GROUP_OPTIONS_FAILED'

export const FETCH_USER_OPTIONS_START = 'FETCH_USER_OPTIONS_START'
export const FETCH_USER_OPTIONS_SUCCESS = 'FETCH_USER_OPTIONS_SUCCESS'
export const FETCH_USER_OPTIONS_FAILED = 'FETCH_USER_OPTIONS_FAILED'

export const FETCH_RESULT_TYPE_OPTIONS_START = 'FETCH_RESULT_TYPE_OPTIONS_START'
export const FETCH_RESULT_TYPE_OPTIONS_SUCCESS = 'FETCH_RESULT_TYPE_OPTIONS_SUCCESS'
export const FETCH_RESULT_TYPE_OPTIONS_FAILED = 'FETCH_RESULT_TYPE_OPTIONS_FAILED'

export const FETCH_FORM_OPTIONS_START = 'FETCH_FORM_OPTIONS_START'
export const FETCH_FORM_OPTIONS_SUCCESS = 'FETCH_FORM_OPTIONS_SUCCESS'
export const FETCH_FORM_OPTIONS_FAILED = 'FETCH_FORM_OPTIONS_FAILED'

export const FETCH_LEVEL_OPTIONS_START = 'FETCH_LEVEL_OPTIONS_START'
export const FETCH_LEVEL_OPTIONS_SUCCESS = 'FETCH_LEVEL_OPTIONS_SUCCESS'
export const FETCH_LEVEL_OPTIONS_FAILED = 'FETCH_LEVEL_OPTIONS_FAILED'

export const FETCH_LEVEL_GROUP_OPTIONS_START = 'FETCH_LEVEL_GROUP_OPTIONS_START'
export const FETCH_LEVEL_GROUP_OPTIONS_SUCCESS = 'FETCH_LEVEL_GROUP_OPTIONS_SUCCESS'
export const FETCH_LEVEL_GROUP_OPTIONS_FAILED = 'FETCH_LEVEL_GROUP_OPTIONS_FAILED'

export const FETCH_STAGE_OPTIONS_START = 'FETCH_STAGE_OPTIONS_START'
export const FETCH_STAGE_OPTIONS_SUCCESS = 'FETCH_STAGE_OPTIONS_SUCCESS'
export const FETCH_STAGE_OPTIONS_FAILED = 'FETCH_STAGE_OPTIONS_FAILED'

export const FETCH_FORCE_RANK_GROUP_OPTIONS_START = 'FETCH_FORCE_RANK_GROUP_OPTIONS_START'
export const FETCH_FORCE_RANK_GROUP_OPTIONS_SUCCESS = 'FETCH_FORCE_RANK_GROUP_OPTIONS_SUCCESS'
export const FETCH_FORCE_RANK_GROUP_OPTIONS_FAILED = 'FETCH_FORCE_RANK_GROUP_OPTIONS_FAILED'

export const FETCH_APPRAISAL_ITEM_TAGS_START = 'FETCH_APPRAISAL_ITEM_TAGS_START'
export const FETCH_APPRAISAL_ITEM_TAGS_SUCCESS = 'FETCH_APPRAISAL_ITEM_TAGS_SUCCESS'
export const FETCH_APPRAISAL_ITEM_TAGS_FAILED = 'FETCH_APPRAISAL_ITEM_TAGS_FAILED'

// filter dropdown options actions
export const FILTER_ORGANIZATION_OPTIONS_START = 'FILTER_ORGANIZATION_OPTIONS_START'
export const FILTER_ORGANIZATION_OPTIONS_SUCCESS = 'FILTER_ORGANIZATION_OPTIONS_SUCCESS'
export const FILTER_ORGANIZATION_OPTIONS_FAILED = 'FILTER_ORGANIZATION_OPTIONS_FAILED'

// company actions
export const FETCH_COMPANY_START = 'FETCH_COMPANY_START'
export const FETCH_COMPANY_SUCCESS = 'FETCH_COMPANY_SUCCESS'
export const FETCH_COMPANY_BY_ID_SUCCESS = 'FETCH_COMPANY_BY_ID_SUCCESS'
export const FETCH_COMPANY_FAILED = 'FETCH_COMPANY_FAILED'
export const CLEAR_SELECTED_COMPANY_RECORD = 'CLEAR_SELECTED_COMPANY_RECORD'

export const CREATE_COMPANY_START = 'CREATE_COMPANY_START'
export const CREATE_COMPANY_SUCCESS = 'CREATE_COMPANY_SUCCESS'
export const CREATE_COMPANY_FAILED = 'CREATE_COMPANY_FAILED'

export const UPDATE_COMPANY_START = 'UPDATE_COMPANY_START'
export const UPDATE_COMPANY_SUCCESS = 'UPDATE_COMPANY_SUCCESS'
export const UPDATE_COMPANY_FAILED = 'UPDATE_COMPANY_FAILED'

export const DELETE_COMPANY_START = 'DELETE_COMPANY_START'
export const DELETE_COMPANY_SUCCESS = 'DELETE_COMPANY_SUCCESS'
export const DELETE_COMPANY_FAILED = 'DELETE_COMPANY_FAILED'

// competecy score actions
export const FETCH_COMPETENCY_SCORE_START = 'FETCH_COMPETENCY_SCORE_START'
export const FETCH_COMPETENCY_SCORE_SUCCESS = 'FETCH_COMPETENCY_SCORE_SUCCESS'
export const FETCH_COMPETENCY_SCORE_FAILED = 'FETCH_COMPETENCY_SCORE_FAILED'

export const FETCH_COMPETENCY_SCORE_BY_ID_START = 'FETCH_COMPETENCY_SCORE_BY_ID_START'
export const FETCH_COMPETENCY_SCORE_BY_ID_SUCCESS = 'FETCH_COMPETENCY_SCORE_BY_ID_SUCCESS'
export const FETCH_COMPETENCY_SCORE_BY_ID_FAILED = 'FETCH_COMPETENCY_SCORE_BY_ID_FAILED'

export const CLEAR_SELECTED_COMPETENCY_SCORE_RECORD = 'CLEAR_SELECTED_COMPETENCY_SCORE_RECORD'

export const CREATE_COMPETENCY_SCORE_START = 'CREATE_COMPETENCY_SCORE_START'
export const CREATE_COMPETENCY_SCORE_SUCCESS = 'CREATE_COMPETENCY_SCORE_SUCCESS'
export const CREATE_COMPETENCY_SCORE_FAILED = 'CREATE_COMPETENCY_SCORE_FAILED'

export const UPDATE_COMPETENCY_SCORE_START = 'UPDATE_COMPETENCY_SCORE_START'
export const UPDATE_COMPETENCY_SCORE_SUCCESS = 'UPDATE_COMPETENCY_SCORE_SUCCESS'
export const UPDATE_COMPETENCY_SCORE_FAILED = 'UPDATE_COMPETENCY_SCORE_FAILED'

export const DELETE_COMPETENCY_SCORE_START = 'DELETE_COMPETENCY_SCORE_START'
export const DELETE_COMPETENCY_SCORE_SUCCESS = 'DELETE_COMPETENCY_SCORE_SUCCESS'
export const DELETE_COMPETENCY_SCORE_FAILED = 'DELETE_COMPETENCY_SCORE_FAILED'

// competecy score group actions
export const FETCH_COMPETENCY_SCORE_GROUP_START = 'FETCH_COMPETENCY_SCORE_GROUP_START'
export const FETCH_COMPETENCY_SCORE_GROUP_SUCCESS = 'FETCH_COMPETENCY_SCORE_GROUP_SUCCESS'
export const FETCH_COMPETENCY_SCORE_GROUP_FAILED = 'FETCH_COMPETENCY_SCORE_GROUP_FAILED'

export const FETCH_COMPETENCY_SCORE_GROUP_BY_ID_START = 'FETCH_COMPETENCY_SCORE_GROUP_BY_ID_START'
export const FETCH_COMPETENCY_SCORE_GROUP_BY_ID_SUCCESS =
  'FETCH_COMPETENCY_SCORE_GROUP_BY_ID_SUCCESS'
export const FETCH_COMPETENCY_SCORE_GROUP_BY_ID_FAILED = 'FETCH_COMPETENCY_SCORE_GROUP_BY_ID_FAILED'

export const CLEAR_SELECTED_COMPETENCY_SCORE_GROUP_RECORD =
  'CLEAR_SELECTED_COMPETENCY_SCORE_GROUP_RECORD'

export const CREATE_COMPETENCY_SCORE_GROUP_START = 'CREATE_COMPETENCY_SCORE_GROUP_START'
export const CREATE_COMPETENCY_SCORE_GROUP_SUCCESS = 'CREATE_COMPETENCY_SCORE_GROUP_SUCCESS'
export const CREATE_COMPETENCY_SCORE_GROUP_FAILED = 'CREATE_COMPETENCY_SCORE_GROUP_FAILED'

export const UPDATE_COMPETENCY_SCORE_GROUP_START = 'UPDATE_COMPETENCY_SCORE_GROUP_START'
export const UPDATE_COMPETENCY_SCORE_GROUP_SUCCESS = 'UPDATE_COMPETENCY_SCORE_GROUP_SUCCESS'
export const UPDATE_COMPETENCY_SCORE_GROUP_FAILED = 'UPDATE_COMPETENCY_SCORE_GROUP_FAILED'

export const DELETE_COMPETENCY_SCORE_GROUP_START = 'DELETE_COMPETENCY_SCORE_GROUP_START'
export const DELETE_COMPETENCY_SCORE_GROUP_SUCCESS = 'DELETE_COMPETENCY_SCORE_GROUP_SUCCESS'
export const DELETE_COMPETENCY_SCORE_GROUP_FAILED = 'DELETE_COMPETENCY_SCORE_GROUP_FAILED'

// perspective actions
export const FETCH_PERSPECTIVE_START = 'FETCH_PERSPECTIVE_START'
export const FETCH_PERSPECTIVE_SUCCESS = 'FETCH_PERSPECTIVE_SUCCESS'
export const FETCH_PERSPECTIVE_BY_ID_SUCCESS = 'FETCH_PERSPECTIVE_BY_ID_SUCCESS'
export const FETCH_PERSPECTIVE_FAILED = 'FETCH_PERSPECTIVE_FAILED'
export const CLEAR_SELECTED_PERSPECTIVE_RECORD = 'CLEAR_SELECTED_PERSPECTIVE_RECORD'

export const CREATE_PERSPECTIVE_START = 'CREATE_PERSPECTIVE_START'
export const CREATE_PERSPECTIVE_SUCCESS = 'CREATE_PERSPECTIVE_SUCCESS'
export const CREATE_PERSPECTIVE_FAILED = 'CREATE_PERSPECTIVE_FAILED'

export const UPDATE_PERSPECTIVE_START = 'UPDATE_PERSPECTIVE_START'
export const UPDATE_PERSPECTIVE_SUCCESS = 'UPDATE_PERSPECTIVE_SUCCESS'
export const UPDATE_PERSPECTIVE_FAILED = 'UPDATE_PERSPECTIVE_FAILED'

export const FETCH_PERSPECTIVE_FILTER_COMPANY_START = 'FETCH_PERSPECTIVE_FILTER_COMPANY_START'
export const FETCH_PERSPECTIVE_FILTER_COMPANY_SUCCESS = 'FETCH_PERSPECTIVE_FILTER_COMPANY_SUCCESS'
export const FETCH_PERSPECTIVE_FILTER_COMPANY_FAILED = 'FETCH_PERSPECTIVE_FILTER_COMPANY_FAILED'

export const FETCH_PERSPECTIVE_FILTER_START = 'FETCH_PERSPECTIVE_FILTER_START'
export const FETCH_PERSPECTIVE_FILTER_SUCCESS = 'FETCH_PERSPECTIVE_FILTER_SUCCESS'
export const FETCH_PERSPECTIVE_FILTER_FAILED = 'FETCH_PERSPECTIVE_FILTER_FAILED'

export const DELETE_PERSPECTIVE_START = 'DELETE_PERSPECTIVE_START'
export const DELETE_PERSPECTIVE_SUCCESS = 'DELETE_PERSPECTIVE_SUCCESS'
export const DELETE_PERSPECTIVE_FAILED = 'DELETE_PERSPECTIVE_FAILED'

export const FETCH_PERSPECTIVE_FILTER_ACTIVE_START = 'FETCH_STRUCTURE_FILTER_ACTIVE_START'
export const FETCH_PERSPECTIVE_FILTER_ACTIVE_SUCCESS = 'FETCH_STRUCTURE_FILTER_ACTIVE_SUCCESS'
export const FETCH_PERSPECTIVE_FILTER_ACTIVE_FAILED = 'FETCH_STRUCTURE_FILTER_ACTIVE_FAILED'

export const FETCH_ROLE_START = 'FETCH_ROLE_START'
export const FETCH_ROLE_SUCCESS = 'FETCH_ROLE_SUCCESS'
export const FETCH_ROLE_BY_ID_SUCCESS = 'FETCH_ROLE_BY_ID_SUCCESS'
export const FETCH_ROLE_ASSIGNMENT_DATA_START = 'FETCH_ROLE_ASSIGNMENT_DATA_START'
export const FETCH_ROLE_ASSIGNMENT_DATA_SUCCESS = 'FETCH_ROLE_ASSIGNMENT_DATA_SUCCESS'
export const FETCH_ROLE_ASSIGNMENT_DATA_FAILED = 'FETCH_ROLE_ASSIGNMENT_DATA_FAILED'
export const FETCH_ROLE_FAILED = 'FETCH_ROLE_FAILED'
export const CLEAR_SELECTED_ROLE_RECORD = 'CLEAR_SELECTED_ROLE_RECORD'

export const CREATE_ROLE_START = 'CREATE_ROLE_START'
export const CREATE_ROLE_SUCCESS = 'CREATE_ROLE_SUCCESS'
export const CREATE_ROLE_FAILED = 'CREATE_ROLE_FAILED'

export const UPDATE_ROLE_START = 'UPDATE_ROLE_START'
export const UPDATE_ROLE_SUCCESS = 'UPDATE_ROLE_SUCCESS'
export const UPDATE_ROLE_FAILED = 'UPDATE_ROLE_FAILED'

export const ASSIGN_ROLE_START = 'ASSIGN_ROLE_START'
export const ASSIGN_ROLE_SUCCESS = 'ASSIGN_ROLE_SUCCESS'
export const ASSIGN_ROLE_FAILED = 'ASSIGN_ROLE_FAILED'

export const DELETE_ROLE_START = 'DELETE_ROLE_START'
export const DELETE_ROLE_SUCCESS = 'DELETE_ROLE_SUCCESS'
export const DELETE_ROLE_FAILED = 'DELETE_ROLE_FAILED'

// form actions
export const FETCH_FORM_START = 'FETCH_FORM_START'
export const FETCH_FORM_SUCCESS = 'FETCH_FORM_SUCCESS'
export const FETCH_FORM_BY_ID_SUCCESS = 'FETCH_FORM_BY_ID_SUCCESS'
export const FETCH_FORM_FAILED = 'FETCH_FORM_FAILED'
export const CLEAR_SELECTED_FORM_RECORD = 'CLEAR_SELECTED_FORM_RECORD'

export const CREATE_FORM_START = 'CREATE_FORM_START'
export const CREATE_FORM_SUCCESS = 'CREATE_FORM_SUCCESS'
export const CREATE_FORM_FAILED = 'CREATE_FORM_FAILED'

export const UPDATE_FORM_START = 'UPDATE_FORM_START'
export const UPDATE_FORM_SUCCESS = 'UPDATE_FORM_SUCCESS'
export const UPDATE_FORM_FAILED = 'UPDATE_FORM_FAILED'

export const DELETE_FORM_START = 'DELETE_FORM_START'
export const DELETE_FORM_SUCCESS = 'DELETE_FORM_SUCCESS'
export const DELETE_FORM_FAILED = 'DELETE_FORM_FAILED'

export const FETCH_FORM_FILTER_COMPANY_START = 'FETCH_FORM_FILTER_COMPANY_START'
export const FETCH_FORM_FILTER_COMPANY_SUCCESS = 'FETCH_FORM_FILTER_COMPANY_SUCCESS'
export const FETCH_FORM_FILTER_COMPANY_FAILED = 'FETCH_FORM_FILTER_COMPANY_FAILED'

export const FETCH_FORM_FILTER_FORM_START = 'FETCH_FORM_FILTER_FORM_START'
export const FETCH_FORM_FILTER_FORM_SUCCESS = 'FETCH_FORM_FILTER_FORM_SUCCESS'
export const FETCH_FORM_FILTER_FORM_FAILED = 'FETCH_FORM_FILTER_FORM_FAILED'

export const FETCH_FORM_FILTER_YEAR_START = 'FETCH_FORM_FILTER_YEAR_START'
export const FETCH_FORM_FILTER_YEAR_SUCCESS = 'FETCH_FORM_FILTER_YEAR_SUCCESS'
export const FETCH_FORM_FILTER_YEAR_FAILED = 'FETCH_FORM_FILTER_YEAR_FAILED'
//structure action

export const FETCH_STRUCTURE_START = 'FETCH_STRUCTURE_START'
export const FETCH_STRUCTURE_SUCCESS = 'FETCH_STRUCTURE_SUCCESS'
export const FETCH_STRUCTURE_BY_ID_SUCCESS = 'FETCH_STRUCTURE_BY_ID_SUCCESS'
export const FETCH_STRUCTURE_FAILED = 'FETCH_STRUCTURE_FAILED'
export const CLEAR_SELECTED_STRUCTURE_RECORD = 'CLEAR_SELECTED_STRUCTURE_RECORD'

export const CREATE_STRUCTURE_START = 'CREATE_STRUCTURE_START'
export const CREATE_STRUCTURE_SUCCESS = 'CREATE_STRUCTURE_SUCCESS'
export const CREATE_STRUCTURE_FAILED = 'CREATE_STRUCTURE_FAILED'

export const UPDATE_STRUCTURE_START = 'UPDATE_STRUCTURE_START'
export const UPDATE_STRUCTURE_SUCCESS = 'UPDATE_STRUCTURE_SUCCESS'
export const UPDATE_STRUCTURE_FAILED = 'UPDATE_STRUCTURE_FAILED'

export const DELETE_STRUCTURE_START = 'DELETE_STRUCTURE_START'
export const DELETE_STRUCTURE_SUCCESS = 'DELETE_STRUCTURE_SUCCESS'
export const DELETE_STRUCTURE_FAILED = 'DELETE_STRUCTURE_FAILED'

export const FETCH_STRUCTURE_FILTER_STRUCTURE_START = 'FETCH_STRUCTURE_FILTER_STRUCTURE_START'
export const FETCH_STRUCTURE_FILTER_STRUCTURE_SUCCESS = 'FETCH_STRUCTURE_FILTER_STRUCTURE_SUCCESS'
export const FETCH_STRUCTURE_FILTER_STRUCTURE_FAILED = 'FETCH_STRUCTURE_FILTER_STRUCTURE_FAILED'

export const FETCH_STRUCTURE_FILTER_STRUCTURE_TYPE_START =
  'FETCH_STRUCTURE_FILTER_STRUCTURE_TYPE_START'
export const FETCH_STRUCTURE_FILTER_STRUCTURE_TYPE_SUCCESS =
  'FETCH_STRUCTURE_FILTER_STRUCTURE_TYPE_SUCCESS'
export const FETCH_STRUCTURE_FILTER_STRUCTURE_TYPE_FAILED =
  'FETCH_STRUCTURE_FILTER_STRUCTURE_TYPE_FAILED'

export const FETCH_STRUCTURE_FILTER_ACTIVE_START = 'FETCH_STRUCTURE_FILTER_ACTIVE_START'
export const FETCH_STRUCTURE_FILTER_ACTIVE_SUCCESS = 'FETCH_STRUCTURE_FILTER_ACTIVE_SUCCESS'
export const FETCH_STRUCTURE_FILTER_ACTIVE_FAILED = 'FETCH_STRUCTURE_FILTER_ACTIVE_FAILED'

// level actions
export const FETCH_LEVEL_START = 'FETCH_LEVEL_START'
export const FETCH_LEVEL_SUCCESS = 'FETCH_LEVEL_SUCCESS'
export const FETCH_LEVEL_BY_ID_SUCCESS = 'FETCH_LEVEL_BY_ID_SUCCESS'
export const FETCH_LEVEL_FAILED = 'FETCH_LEVEL_FAILED'
export const CLEAR_SELECTED_LEVEL_RECORD = 'CLEAR_SELECTED_LEVEL_RECORD'

export const CREATE_LEVEL_START = 'CREATE_LEVEL_START'
export const CREATE_LEVEL_SUCCESS = 'CREATE_LEVEL_SUCCESS'
export const CREATE_LEVEL_FAILED = 'CREATE_LEVEL_FAILED'

export const UPDATE_LEVEL_START = 'UPDATE_LEVEL_START'
export const UPDATE_LEVEL_SUCCESS = 'UPDATE_LEVEL_SUCCESS'
export const UPDATE_LEVEL_FAILED = 'UPDATE_LEVEL_FAILED'

export const DELETE_LEVEL_START = 'DELETE_LEVEL_START'
export const DELETE_LEVEL_SUCCESS = 'DELETE_LEVEL_SUCCESS'
export const DELETE_LEVEL_FAILED = 'DELETE_LEVEL_FAILED'

export const IMPORT_LEVEL_START = 'IMPORT_LEVEL_START'
export const IMPORT_LEVEL_SUCCESS = 'IMPORT_LEVEL_SUCCESS'
export const IMPORT_LEVEL_FAILED = 'IMPORT_LEVEL_FAILED'

export const EXPORT_LEVEL_START = 'EXPORT_LEVEL_START'
export const EXPORT_LEVEL_SUCCESS = 'EXPORT_LEVEL_SUCCESS'
export const EXPORT_LEVEL_FAILED = 'EXPORT_LEVEL_FAILED'

export const DOWNLOAD_LEVEL_TEMPLATE_START = 'DOWNLOAD_LEVEL_TEMPLATE_START'
export const DOWNLOAD_LEVEL_TEMPLATE_SUCCESS = 'DOWNLOAD_LEVEL_TEMPLATE_SUCCESS'
export const DOWNLOAD_LEVEL_TEMPLATE_FAILED = 'DOWNLOAD_LEVEL_TEMPLATE_FAILED'

export const FETCH_LEVEL_FILTER_COMPANY_START = 'FETCH_LEVEL_FILTER_COMPANY_START'
export const FETCH_LEVEL_FILTER_COMPANY_SUCCESS = 'FETCH_LEVEL_FILTER_COMPANY_SUCCESS'
export const FETCH_LEVEL_FILTER_COMPANY_FAILED = 'FETCH_LEVEL_FILTER_COMPANY_FAILED'

export const FETCH_LEVEL_FILTER_LEVEL_START = 'FETCH_LEVEL_FILTER_LEVEL_START'
export const FETCH_LEVEL_FILTER_LEVEL_SUCCESS = 'FETCH_LEVEL_FILTER_LEVEL_SUCCESS'
export const FETCH_LEVEL_FILTER_LEVEL_FAILED = 'FETCH_LEVEL_FILTER_LEVEL_FAILED'

export const FETCH_LEVEL_FILTER_PARENT_LEVEL_START = 'FETCH_LEVEL_FILTER_PARENT_LEVEL_START'
export const FETCH_LEVEL_FILTER_PARENT_LEVEL_SUCCESS = 'FETCH_LEVEL_FILTER_PARENT_LEVEL_SUCCESS'
export const FETCH_LEVEL_FILTER_PARENT_LEVEL_FAILED = 'FETCH_LEVEL_FILTER_PARENT_LEVEL_FAILED'

export const FETCH_LEVEL_FILTER_ACTIVE_START = 'FETCH_LEVEL_FILTER_ACTIVE_START'
export const FETCH_LEVEL_FILTER_ACTIVE_SUCCESS = 'FETCH_LEVEL_FILTER_ACTIVE_SUCCESS'
export const FETCH_LEVEL_FILTER_ACTIVE_FAILED = 'FETCH_LEVEL_FILTER_ACTIVE_FAILED'

// level actions
export const FETCH_LEVEL_GROUP_START = 'FETCH_LEVEL_GROUP_START'
export const FETCH_LEVEL_GROUP_SUCCESS = 'FETCH_LEVEL_GROUP_SUCCESS'
export const FETCH_LEVEL_GROUP_FAILED = 'FETCH_LEVEL_GROUP_FAILED'

export const FETCH_LEVEL_GROUP_BY_ID_SUCCESS = 'FETCH_LEVEL_GROUP_BY_ID_SUCCESS'
export const CLEAR_SELECTED_LEVEL_GROUP_RECORD = 'CLEAR_SELECTED_LEVEL_GROUP_RECORD'

export const CREATE_LEVEL_GROUP_START = 'CREATE_LEVEL_GROUP_START'
export const CREATE_LEVEL_GROUP_SUCCESS = 'CREATE_LEVEL_GROUP_SUCCESS'
export const CREATE_LEVEL_GROUP_FAILED = 'CREATE_LEVEL_GROUP_FAILED'

export const UPDATE_LEVEL_GROUP_START = 'UPDATE_LEVEL_GROUP_START'
export const UPDATE_LEVEL_GROUP_SUCCESS = 'UPDATE_LEVEL_GROUP_SUCCESS'
export const UPDATE_LEVEL_GROUP_FAILED = 'UPDATE_LEVEL_GROUP_FAILED'

export const DELETE_LEVEL_GROUP_START = 'DELETE_LEVEL_GROUP_START'
export const DELETE_LEVEL_GROUP_SUCCESS = 'DELETE_LEVEL_GROUP_SUCCESS'
export const DELETE_LEVEL_GROUP_FAILED = 'DELETE_LEVEL_GROUP_FAILED'

export const FETCH_LEVEL_GROUP_FILTER_LEVEL_GROUP_START =
  'FETCH_LEVEL_GROUP_FILTER_LEVEL_GROUP_START'
export const FETCH_LEVEL_GROUP_FILTER_LEVEL_GROUP_SUCCESS =
  'FETCH_LEVEL_GROUP_FILTER_LEVEL_GROUP_SUCCESS'
export const FETCH_LEVEL_GROUP_FILTER_LEVEL_GROUP_FAILED =
  'FETCH_LEVEL_GROUP_FILTER_LEVEL_GROUP_FAILED'

export const FETCH_LEVEL_GROUP_FILTER_ACTIVE_START = 'FETCH_LEVEL_GROUP_FILTER_ACTIVE_START'
export const FETCH_LEVEL_GROUP_FILTER_ACTIVE_SUCCESS = 'FETCH_LEVEL_GROUP_FILTER_ACTIVE_SUCCESS'
export const FETCH_LEVEL_GROUP_FILTER_ACTIVE_FAILED = 'FETCH_LEVEL_GROUP_FILTER_ACTIVE_FAILED'

// level actions
export const FETCH_POSITION_GROUP_START = 'FETCH_POSITION_GROUP_START'
export const FETCH_POSITION_GROUP_SUCCESS = 'FETCH_POSITION_GROUP_SUCCESS'
export const FETCH_POSITION_GROUP_BY_ID_SUCCESS = 'FETCH_POSITION_GROUP_BY_ID_SUCCESS'
export const FETCH_POSITION_GROUP_FAILED = 'FETCH_POSITION_GROUP_FAILED'
export const CLEAR_SELECTED_POSITION_GROUP_RECORD = 'CLEAR_SELECTED_POSITION_GROUP_RECORD'

export const CREATE_POSITION_GROUP_START = 'CREATE_POSITION_GROUP_START'
export const CREATE_POSITION_GROUP_SUCCESS = 'CREATE_POSITION_GROUP_SUCCESS'
export const CREATE_POSITION_GROUP_FAILED = 'CREATE_POSITION_GROUP_FAILED'

export const UPDATE_POSITION_GROUP_START = 'UPDATE_POSITION_GROUP_START'
export const UPDATE_POSITION_GROUP_SUCCESS = 'UPDATE_POSITION_GROUP_SUCCESS'
export const UPDATE_POSITION_GROUP_FAILED = 'UPDATE_POSITION_GROUP_FAILED'

export const DELETE_POSITION_GROUP_START = 'DELETE_POSITION_GROUP_START'
export const DELETE_POSITION_GROUP_SUCCESS = 'DELETE_POSITION_GROUP_SUCCESS'
export const DELETE_POSITION_GROUP_FAILED = 'DELETE_POSITION_GROUP_FAILED'

export const IMPORT_POSITION_GROUP_START = 'IMPORT_POSITION_GROUP_START'
export const IMPORT_POSITION_GROUP_SUCCESS = 'IMPORT_POSITION_GROUP_SUCCESS'
export const IMPORT_POSITION_GROUP_FAILED = 'IMPORT_POSITION_GROUP_FAILED'

export const EXPORT_POSITION_GROUP_START = 'EXPORT_POSITION_GROUP_START'
export const EXPORT_POSITION_GROUP_SUCCESS = 'EXPORT_POSITION_GROUP_SUCCESS'
export const EXPORT_POSITION_GROUP_FAILED = 'EXPORT_POSITION_GROUP_FAILED'

export const DOWNLOAD_POSITION_GROUP_TEMPLATE_START = 'DOWNLOAD_POSITION_GROUP_TEMPLATE_START'
export const DOWNLOAD_POSITION_GROUP_TEMPLATE_SUCCESS = 'DOWNLOAD_POSITION_GROUP_TEMPLATE_SUCCESS'
export const DOWNLOAD_POSITION_GROUP_TEMPLATE_FAILED = 'DOWNLOAD_POSITION_GROUP_TEMPLATE_FAILED'

export const FETCH_POSITION_GROUP_FILTER_COMPANY_START = 'FETCH_POSITION_GROUP_FILTER_COMPANY_START'
export const FETCH_POSITION_GROUP_FILTER_COMPANY_SUCCESS =
  'FETCH_POSITION_GROUP_FILTER_COMPANY_SUCCESS'
export const FETCH_POSITION_GROUP_FILTER_COMPANY_FAILED =
  'FETCH_POSITION_GROUP_FILTER_COMPANY_FAILED'

export const FETCH_POSITION_GROUP_FILTER_POSITION_GROUP_START =
  'FETCH_POSITION_GROUP_FILTER_POSITION_GROUP_START'
export const FETCH_POSITION_GROUP_FILTER_POSITION_GROUP_SUCCESS =
  'FETCH_POSITION_GROUP_FILTER_POSITION_GROUP_SUCCESS'
export const FETCH_POSITION_GROUP_FILTER_POSITION_GROUP_FAILED =
  'FETCH_POSITION_GROUP_FILTER_POSITION_GROUP_FAILED'

export const FETCH_POSITION_GROUP_FILTER_PARENT_POSITION_GROUP_START =
  'FETCH_POSITION_GROUP_FILTER_PARENT_POSITION_GROUP_START'
export const FETCH_POSITION_GROUP_FILTER_PARENT_POSITION_GROUP_SUCCESS =
  'FETCH_POSITION_GROUP_FILTER_PARENT_POSITION_GROUP_SUCCESS'
export const FETCH_POSITION_GROUP_FILTER_PARENT_POSITION_GROUP_FAILED =
  'FETCH_POSITION_GROUP_FILTER_PARENT_POSITION_GROUP_FAILED'

export const FETCH_POSITION_GROUP_FILTER_ACTIVE_START = 'FETCH_POSITION_GROUP_FILTER_ACTIVE_START'
export const FETCH_POSITION_GROUP_FILTER_ACTIVE_SUCCESS =
  'FETCH_POSITION_GROUP_FILTER_ACTIVE_SUCCESS'
export const FETCH_POSITION_GROUP_FILTER_ACTIVE_FAILED = 'FETCH_POSITION_GROUP_FILTER_ACTIVE_FAILED'

// password Policy actions
export const FETCH_PASSWORD_POLICY_START = 'FETCH_PASSWORD_POLICY_START'
export const FETCH_PASSWORD_POLICY_SUCCESS = 'FETCH_PASSWORD_POLICY_SUCCESS'
export const FETCH_PASSWORD_POLICY_BY_ID_SUCCESS = 'FETCH_PASSWORD_POLICY_BY_ID_SUCCESS'
export const FETCH_PASSWORD_POLICY_FAILED = 'FETCH_PASSWORD_POLICY_FAILED'
export const CLEAR_SELECTED_PASSWORD_POLICY_RECORD = 'CLEAR_SELECTED_PASSWORD_POLICY_RECORD'

export const CREATE_PASSWORD_POLICY_START = 'CREATE_PASSWORD_POLICY_START'
export const CREATE_PASSWORD_POLICY_SUCCESS = 'CREATE_PASSWORD_POLICY_SUCCESS'
export const CREATE_PASSWORD_POLICY_FAILED = 'CREATE_PASSWORD_POLICY_FAILED'

export const UPDATE_PASSWORD_POLICY_START = 'UPDATE_PASSWORD_POLICY_START'
export const UPDATE_PASSWORD_POLICY_SUCCESS = 'UPDATE_PASSWORD_POLICY_SUCCESS'
export const UPDATE_PASSWORD_POLICY_FAILED = 'UPDATE_PASSWORD_POLICY_FAILED'

export const DELETE_PASSWORD_POLICY_START = 'DELETE_PASSWORD_POLICY_START'
export const DELETE_PASSWORD_POLICY_SUCCESS = 'DELETE_PASSWORD_POLICY_SUCCESS'
export const DELETE_PASSWORD_POLICY_FAILED = 'DELETE_PASSWORD_POLICY_FAILED'

export const FETCH_PASSWORD_POLICY_MINIMUM_AGE_OPTIONS_START =
  'FETCH_PASSWORD_POLICY_MINIMUM_AGE_OPTIONS_START'
export const FETCH_PASSWORD_POLICY_MINIMUM_AGE_OPTIONS_SUCCESS =
  'FETCH_PASSWORD_POLICY_MINIMUM_AGE_OPTIONS_SUCCESS'
export const FETCH_PASSWORD_POLICY_MINIMUM_AGE_OPTIONS_FAILED =
  'FETCH_PASSWORD_POLICY_MINIMUM_AGE_OPTIONS_FAILED'

export const FETCH_PASSWORD_POLICY_RESET_TICKET_MAX_AGE_OPTIONS_START =
  'FETCH_PASSWORD_POLICY_RESET_TICKET_MAX_AGE_OPTIONS_START'
export const FETCH_PASSWORD_POLICY_RESET_TICKET_MAX_AGE_OPTIONS_SUCCESS =
  'FETCH_PASSWORD_POLICY_RESET_TICKET_MAX_AGE_OPTIONS_SUCCESS'
export const FETCH_PASSWORD_POLICY_RESET_TICKET_MAX_AGE_OPTIONS_FAILED =
  'FETCH_PASSWORD_POLICY_RESET_TICKET_MAX_AGE_OPTIONS_FAILED'

export const FETCH_PASSWORD_POLICY_HISTORY_COUNT_OPTIONS_START =
  'FETCH_PASSWORD_POLICY_HISTORY_COUNT_OPTIONS_START'
export const FETCH_PASSWORD_POLICY_HISTORY_COUNT_OPTIONS_SUCCESS =
  'FETCH_PASSWORD_POLICY_HISTORY_COUNT_OPTIONS_SUCCESS'
export const FETCH_PASSWORD_POLICY_HISTORY_COUNT_OPTIONS_FAILED =
  'FETCH_PASSWORD_POLICY_HISTORY_COUNT_OPTIONS_FAILED'

export const FETCH_PASSWORD_POLICY_MAXIMUM_AGE_OPTIONS_START =
  'FETCH_PASSWORD_POLICY_MAXIMUM_AGE_OPTIONS_START'
export const FETCH_PASSWORD_POLICY_MAXIMUM_AGE_OPTIONS_SUCCESS =
  'FETCH_PASSWORD_POLICY_MAXIMUM_AGE_OPTIONS_SUCCESS'
export const FETCH_PASSWORD_POLICY_MAXIMUM_AGE_OPTIONS_FAILED =
  'FETCH_PASSWORD_POLICY_MAXIMUM_AGE_OPTIONS_FAILED'

export const FETCH_PASSWORD_POLICY_WARNING_TIME_OPTIONS_START =
  'FETCH_PASSWORD_POLICY_WARNING_TIME_OPTIONS_START'
export const FETCH_PASSWORD_POLICY_WARNING_TIME_OPTIONS_SUCCESS =
  'FETCH_PASSWORD_POLICY_WARNING_TIME_OPTIONS_SUCCESS'
export const FETCH_PASSWORD_POLICY_WARNING_TIME_OPTIONS_FAILED =
  'FETCH_PASSWORD_POLICY_WARNING_TIME_OPTIONS_FAILED'

export const FETCH_PASSWORD_POLICY_RESET_FAILURE_COUNT_OPTIONS_START =
  'FETCH_PASSWORD_POLICY_RESET_FAILURE_COUNT_OPTIONS_START'
export const FETCH_PASSWORD_POLICY_RESET_FAILURE_COUNT_OPTIONS_SUCCESS =
  'FETCH_PASSWORD_POLICY_RESET_FAILURE_COUNT_OPTIONS_SUCCESS'
export const FETCH_PASSWORD_POLICY_RESET_FAILURE_COUNT_OPTIONS_FAILED =
  'FETCH_PASSWORD_POLICY_RESET_FAILURE_COUNT_OPTIONS_FAILED'

export const FETCH_PASSWORD_POLICY_LOCKOUT_DURATION_OPTIONS_START =
  'FETCH_PASSWORD_POLICY_LOCKOUT_DURATION_OPTIONS_START'
export const FETCH_PASSWORD_POLICY_LOCKOUT_DURATION_OPTIONS_SUCCESS =
  'FETCH_PASSWORD_POLICY_LOCKOUT_DURATION_OPTIONS_SUCCESS'
export const FETCH_PASSWORD_POLICY_LOCKOUT_DURATION_OPTIONS_FAILED =
  'FETCH_PASSWORD_POLICY_LOCKOUT_DURATION_OPTIONS_FAILED'

export const FETCH_PASSWORD_POLICY_FILTER_PASSWORD_POLICY_START =
  'FETCH_PASSWORD_POLICY_FILTER_PASSWORD_POLICY_START'
export const FETCH_PASSWORD_POLICY_FILTER_PASSWORD_POLICY_SUCCESS =
  'FETCH_PASSWORD_POLICY_FILTER_PASSWORD_POLICY_SUCCESS'
export const FETCH_PASSWORD_POLICY_FILTER_PASSWORD_POLICY_FAILED =
  'FETCH_PASSWORD_POLICY_FILTER_PASSWORD_POLICY_FAILED'

// password Policy actions
export const FETCH_EMAIL_SERVER_START = 'FETCH_EMAIL_SERVER_START'
export const FETCH_EMAIL_SERVER_SUCCESS = 'FETCH_EMAIL_SERVER_SUCCESS'
export const FETCH_EMAIL_SERVER_BY_ID_SUCCESS = 'FETCH_EMAIL_SERVER_BY_ID_SUCCESS'
export const FETCH_EMAIL_SERVER_FAILED = 'FETCH_EMAIL_SERVER_FAILED'
export const CLEAR_SELECTED_EMAIL_SERVER_RECORD = 'CLEAR_SELECTED_EMAIL_SERVER_RECORD'

export const CREATE_EMAIL_SERVER_START = 'CREATE_EMAIL_SERVER_START'
export const CREATE_EMAIL_SERVER_SUCCESS = 'CREATE_EMAIL_SERVER_SUCCESS'
export const CREATE_EMAIL_SERVER_FAILED = 'CREATE_EMAIL_SERVER_FAILED'

export const UPDATE_EMAIL_SERVER_START = 'UPDATE_EMAIL_SERVER_START'
export const UPDATE_EMAIL_SERVER_SUCCESS = 'UPDATE_EMAIL_SERVER_SUCCESS'
export const UPDATE_EMAIL_SERVER_FAILED = 'UPDATE_EMAIL_SERVER_FAILED'

export const DELETE_EMAIL_SERVER_START = 'DELETE_EMAIL_SERVER_START'
export const DELETE_EMAIL_SERVER_SUCCESS = 'DELETE_EMAIL_SERVER_SUCCESS'
export const DELETE_EMAIL_SERVER_FAILED = 'DELETE_EMAIL_SERVER_FAILED'

export const FETCH_EMAIL_SERVER_FILTER_EMAIL_SERVER_START =
  'FETCH_EMAIL_SERVER_FILTER_EMAIL_SERVER_START'
export const FETCH_EMAIL_SERVER_FILTER_EMAIL_SERVER_SUCCESS =
  'FETCH_EMAIL_SERVER_FILTER_EMAIL_SERVER_SUCCESS'
export const FETCH_EMAIL_SERVER_FILTER_EMAIL_SERVER_FAILED =
  'FETCH_EMAIL_SERVER_FILTER_EMAIL_SERVER_FAILED'

// force rank actions

export const FETCH_FORCERANK_START = 'FETCH_FORCERANK_START'
export const FETCH_FORCERANK_SUCCESS = 'FETCH_FORCERANK_SUCCESS'
export const FETCH_FORCERANK_FAILED = 'FETCH_FORCERANK_FAILED'

export const CREATE_FORCERANK_START = 'CREATE_FORCERANK_START'
export const CREATE_FORCERANK_SUCCESS = 'CREATE_FORCERANK_SUCCESS'
export const CREATE_FORCERANK_FAILED = 'CREATE_FORCERANK_FAILED'

export const DOWNLOAD_FORCERANK_TEMPLATE_START = 'DOWNLOAD_FORCERANK_TEMPLATE_START'
export const DOWNLOAD_FORCERANK_TEMPLATE_SUCCESS = 'DOWNLOAD_FORCERANK_TEMPLATE_SUCCESS'
export const DOWNLOAD_FORCERANK_TEMPLATE_FAILED = 'DOWNLOAD_FORCERANK_TEMPLATE_FAILED'

export const FETCH_FORCERANK_FILTER_COMPANY_START = 'FETCH_FORCERANK_FILTER_COMPANY_START'
export const FETCH_FORCERANK_FILTER_COMPANY_SUCCESS = 'FETCH_FORCERANK_FILTER_COMPANY_SUCCESS'
export const FETCH_FORCERANK_FILTER_COMPANY_FAILED = 'FETCH_FORCERANK_FILTER_COMPANY_FAILED'

export const FETCH_FORCERANK_FILTER_START = 'FETCH_FORCERANK_FILTER_START'
export const FETCH_FORCERANK_FILTER_SUCCESS = 'FETCH_FORCERANK_FILTER_SUCCESS'
export const FETCH_FORCERANK_FILTER_FAILED = 'FETCH_FORCERANK_FILTER_FAILED'

export const FETCH_GRADE_OPTIONS_START = 'FETCH_GRADE_OPTIONS_START'
export const FETCH_GRADE_OPTIONS_SUCCESS = 'FETCH_GRADE_OPTIONS_SUCCESS'
export const FETCH_GRADE_OPTIONS_FAILED = 'FETCH_GRADE_OPTIONS_FAILED'

export const FETCH_FORCERANK_LIST_START = 'FETCH_FORCERANK_LIST_START'
export const FETCH_FORCERANK_LIST_SUCCESS = 'FETCH_FORCERANK_LIST_SUCCESS'
export const FETCH_FORCERANK_LIST_FAILED = 'FETCH_FORCERANK_LIST_FAILED'

export const FETCH_FORCERANK_CALCULATE_START = 'FETCH_FORCERANK_CALCULATE_START'
export const FETCH_FORCERANK_CALCULATE_SUCCESS = 'FETCH_FORCERANK_CALCULATE_SUCCESS'
export const FETCH_FORCERANK_CALCULATE_FAILED = 'FETCH_FORCERANK_CALCULATE_FAILED'

export const FETCH_ADJUST_START = 'FETCH_ADJUST_START'
export const FETCH_ADJUST_SUCCESS = 'FETCH_ADJUST_SUCCESS'
export const FETCH_ADJUST_FAILED = 'FETCH_ADJUST_FAILED'

// horizontal force rank actions

export const FETCH_HORIZONTAL_FORCERANK_START = 'FETCH_HORIZONTAL_FORCERANK_START'
export const FETCH_HORIZONTAL_FORCERANK_SUCCESS = 'FETCH_HORIZONTAL_FORCERANK_SUCCESS'
export const FETCH_HORIZONTAL_FORCERANK_FAILED = 'FETCH_HORIZONTAL_FORCERANK_FAILED'

export const CREATE_HORIZONTAL_FORCERANK_START = 'CREATE_HORIZONTAL_FORCERANK_START'
export const CREATE_HORIZONTAL_FORCERANK_SUCCESS = 'CREATE_HORIZONTAL_FORCERANK_SUCCESS'
export const CREATE_HORIZONTAL_FORCERANK_FAILED = 'CREATE_HORIZONTAL_FORCERANK_FAILED'

export const DOWNLOAD_HORIZONTAL_FORCERANK_TEMPLATE_START =
  'DOWNLOAD_HORIZONTAL_FORCERANK_TEMPLATE_START'
export const DOWNLOAD_HORIZONTAL_FORCERANK_TEMPLATE_SUCCESS =
  'DOWNLOAD_HORIZONTAL_FORCERANK_TEMPLATE_SUCCESS'
export const DOWNLOAD_HORIZONTAL_FORCERANK_TEMPLATE_FAILED =
  'DOWNLOAD_HORIZONTAL_FORCERANK_TEMPLATE_FAILED'

export const FETCH_HORIZONTAL_FORCERANK_FILTER_COMPANY_START =
  'FETCH_HORIZONTAL_FORCERANK_FILTER_COMPANY_START'
export const FETCH_HORIZONTAL_FORCERANK_FILTER_COMPANY_SUCCESS =
  'FETCH_HORIZONTAL_FORCERANK_FILTER_COMPANY_SUCCESS'
export const FETCH_HORIZONTAL_FORCERANK_FILTER_COMPANY_FAILED =
  'FETCH_HORIZONTAL_FORCERANK_FILTER_COMPANY_FAILED'

export const FETCH_HORIZONTAL_FORCERANK_FILTER_START = 'FETCH_HORIZONTAL_FORCERANK_FILTER_START'
export const FETCH_HORIZONTAL_FORCERANK_FILTER_SUCCESS = 'FETCH_HORIZONTAL_FORCERANK_FILTER_SUCCESS'
export const FETCH_HORIZONTAL_FORCERANK_FILTER_FAILED = 'FETCH_HORIZONTAL_FORCERANK_FILTER_FAILED'

export const FETCH_HORIZONTAL_FORCERANK_GRADE_START = 'FETCH_HORIZONTAL_FORCERANK_GRADE_START'
export const FETCH_HORIZONTAL_FORCERANK_GRADE_SUCCESS = 'FETCH_HORIZONTAL_FORCERANK_GRADE_SUCCESS'
export const FETCH_HORIZONTAL_FORCERANK_GRADE_FAILED = 'FETCH_HORIZONTAL_FORCERANK_GRADE_FAILED'

export const FETCH_HORIZONTAL_FORCERANK_TABLE_START = 'FETCH_HORIZONTAL_FORCERANK_TABLE_START'
export const FETCH_HORIZONTAL_FORCERANK_TABLE_SUCCESS = 'FETCH_HORIZONTAL_FORCERANK_TABLE_SUCCESS'
export const FETCH_HORIZONTAL_FORCERANK_TABLE_FAILED = 'FETCH_HORIZONTAL_FORCERANK_TABLE_FAILED'

export const FETCH_HORIZONTAL_FORCERANK_LIST_START = 'FETCH_HORIZONTAL_FORCERANK_LIST_START'
export const FETCH_HORIZONTAL_FORCERANK_LIST_SUCCESS = 'FETCH_HORIZONTAL_FORCERANK_LIST_SUCCESS'
export const FETCH_HORIZONTAL_FORCERANK_LIST_FAILED = 'FETCH_HORIZONTAL_FORCERANK_LIST_FAILED'

export const FETCH_HORIZONTAL_FORCERANK_CALCULATE_START =
  'FETCH_HORIZONTAL_FORCERANK_CALCULATE_START'
export const FETCH_HORIZONTAL_FORCERANK_CALCULATE_SUCCESS =
  'FETCH_HORIZONTAL_FORCERANK_CALCULATE_SUCCESS'
export const FETCH_HORIZONTAL_FORCERANK_CALCULATE_FAILED =
  'FETCH_HORIZONTAL_FORCERANK_CALCULATE_FAILED'

export const CLEAR_HORIZONTAL_RECORD = 'CLEAR_HORIZONTAL_RECORD'

// vertical force rank actions

export const FETCH_VERTICAL_FORCERANK_START = 'FETCH_VERTICAL_FORCERANK_START'
export const FETCH_VERTICAL_FORCERANK_SUCCESS = 'FETCH_VERTICAL_FORCERANK_SUCCESS'
export const FETCH_VERTICAL_FORCERANK_FAILED = 'FETCH_VERTICAL_FORCERANK_FAILED'

export const CREATE_VERTICAL_FORCERANK_START = 'CREATE_VERTICAL_FORCERANK_START'
export const CREATE_VERTICAL_FORCERANK_SUCCESS = 'CREATE_VERTICAL_FORCERANK_SUCCESS'
export const CREATE_VERTICAL_FORCERANK_FAILED = 'CREATE_VERTICAL_FORCERANK_FAILED'

export const DOWNLOAD_VERTICAL_FORCERANK_TEMPLATE_START =
  'DOWNLOAD_VERTICAL_FORCERANK_TEMPLATE_START'
export const DOWNLOAD_VERTICAL_FORCERANK_TEMPLATE_SUCCESS =
  'DOWNLOAD_VERTICAL_FORCERANK_TEMPLATE_SUCCESS'
export const DOWNLOAD_VERTICAL_FORCERANK_TEMPLATE_FAILED =
  'DOWNLOAD_VERTICAL_FORCERANK_TEMPLATE_FAILED'

export const FETCH_VERTICAL_FORCERANK_FILTER_COMPANY_START =
  'FETCH_VERTICAL_FORCERANK_FILTER_COMPANY_START'
export const FETCH_VERTICAL_FORCERANK_FILTER_COMPANY_SUCCESS =
  'FETCH_VERTICAL_FORCERANK_FILTER_COMPANY_SUCCESS'
export const FETCH_VERTICAL_FORCERANK_FILTER_COMPANY_FAILED =
  'FETCH_VERTICAL_FORCERANK_FILTER_COMPANY_FAILED'

export const FETCH_VERTICAL_FORCERANK_FILTER_START = 'FETCH_VERTICAL_FORCERANK_FILTER_START'
export const FETCH_VERTICAL_FORCERANK_FILTER_SUCCESS = 'FETCH_VERTICAL_FORCERANK_FILTER_SUCCESS'
export const FETCH_VERTICAL_FORCERANK_FILTER_FAILED = 'FETCH_VERTICAL_FORCERANK_FILTER_FAILED'

export const FETCH_VERTICAL_FORCERANK_GRADE_START = 'FETCH_VERTICAL_FORCERANK_GRADE_START'
export const FETCH_VERTICAL_FORCERANK_GRADE_SUCCESS = 'FETCH_VERTICAL_FORCERANK_GRADE_SUCCESS'
export const FETCH_VERTICAL_FORCERANK_GRADE_FAILED = 'FETCH_VERTICAL_FORCERANK_GRADE_FAILED'

export const FETCH_VERTICAL_FORCERANK_LIST_START = 'FETCH_VERTICAL_FORCERANK_LIST_START'
export const FETCH_VERTICAL_FORCERANK_LIST_SUCCESS = 'FETCH_VERTICAL_FORCERANK_LIST_SUCCESS'
export const FETCH_VERTICAL_FORCERANK_LIST_FAILED = 'FETCH_VERTICAL_FORCERANK_LIST_FAILED'

export const FETCH_VERTICAL_FORCERANK_CALCULATE_START = 'FETCH_VERTICAL_FORCERANK_CALCULATE_START'
export const FETCH_VERTICAL_FORCERANK_CALCULATE_SUCCESS =
  'FETCH_VERTICAL_FORCERANK_CALCULATE_SUCCESS'
export const FETCH_VERTICAL_FORCERANK_CALCULATE_FAILED = 'FETCH_VERTICAL_FORCERANK_CALCULATE_FAILED'

// position actions
export const FETCH_POSITION_START = 'FETCH_POSITION_START'
export const FETCH_POSITION_SUCCESS = 'FETCH_POSITION_SUCCESS'
export const FETCH_POSITION_BY_ID_SUCCESS = 'FETCH_POSITION_BY_ID_SUCCESS'
export const FETCH_POSITION_FAILED = 'FETCH_POSITION_FAILED'
export const CLEAR_SELECTED_POSITION_RECORD = 'CLEAR_SELECTED_POSITION_RECORD'

export const CREATE_POSITION_START = 'CREATE_POSITION_START'
export const CREATE_POSITION_SUCCESS = 'CREATE_POSITION_SUCCESS'
export const CREATE_POSITION_FAILED = 'CREATE_POSITION_FAILED'

export const UPDATE_POSITION_START = 'UPDATE_POSITION_START'
export const UPDATE_POSITION_SUCCESS = 'UPDATE_POSITION_SUCCESS'
export const UPDATE_POSITION_FAILED = 'UPDATE_POSITION_FAILED'

export const DELETE_POSITION_START = 'DELETE_POSITION_START'
export const DELETE_POSITION_SUCCESS = 'DELETE_POSITION_SUCCESS'
export const DELETE_POSITION_FAILED = 'DELETE_POSITION_FAILED'

export const IMPORT_POSITION_START = 'IMPORT_POSITION_START'
export const IMPORT_POSITION_SUCCESS = 'IMPORT_POSITION_SUCCESS'
export const IMPORT_POSITION_FAILED = 'IMPORT_POSITION_FAILED'

export const EXPORT_POSITION_START = 'EXPORT_POSITION_START'
export const EXPORT_POSITION_SUCCESS = 'EXPORT_POSITION_SUCCESS'
export const EXPORT_POSITION_FAILED = 'EXPORT_POSITION_FAILED'

export const DOWNLOAD_POSITION_TEMPLATE_START = 'DOWNLOAD_POSITION_TEMPLATE_START'
export const DOWNLOAD_POSITION_TEMPLATE_SUCCESS = 'DOWNLOAD_POSITION_TEMPLATE_SUCCESS'
export const DOWNLOAD_POSITION_TEMPLATE_FAILED = 'DOWNLOAD_POSITION_TEMPLATE_FAILED'

export const FETCH_POSITION_FILTER_COMPANY_START = 'FETCH_POSITION_FILTER_COMPANY_START'
export const FETCH_POSITION_FILTER_COMPANY_SUCCESS = 'FETCH_POSITION_FILTER_COMPANY_SUCCESS'
export const FETCH_POSITION_FILTER_COMPANY_FAILED = 'FETCH_POSITION_FILTER_COMPANY_FAILED'

export const FETCH_POSITION_FILTER_POSITION_START = 'FETCH_POSITION_FILTER_POSITION_START'
export const FETCH_POSITION_FILTER_POSITION_SUCCESS = 'FETCH_POSITION_FILTER_POSITION_SUCCESS'
export const FETCH_POSITION_FILTER_POSITION_FAILED = 'FETCH_POSITION_FILTER_POSITION_FAILED'

// kpi actions
export const FETCH_KPI_TYPE_START = 'FETCH_KPI_TYPE_START'
export const FETCH_KPI_TYPE_SUCCESS = 'FETCH_KPI_TYPE_SUCCESS'
export const FETCH_KPI_TYPE_BY_ID_SUCCESS = 'FETCH_KPI_TYPE_BY_ID_SUCCESS'
export const FETCH_KPI_TYPE_FAILED = 'FETCH_KPI_TYPE_FAILED'
export const CLEAR_SELECTED_KPI_TYPE_RECORD = 'CLEAR_SELECTED_KPI_TYPE_RECORD'

export const CREATE_KPI_TYPE_START = 'CREATE_KPI_TYPE_START'
export const CREATE_KPI_TYPE_SUCCESS = 'CREATE_KPI_TYPE_SUCCESS'
export const CREATE_KPI_TYPE_FAILED = 'CREATE_KPI_TYPE_FAILED'

export const UPDATE_KPI_TYPE_START = 'UPDATE_KPI_TYPE_START'
export const UPDATE_KPI_TYPE_SUCCESS = 'UPDATE_KPI_TYPE_SUCCESS'
export const UPDATE_KPI_TYPE_FAILED = 'UPDATE_KPI_TYPE_FAILED'

export const DELETE_KPI_TYPE_START = 'DELETE_KPI_TYPE_START'
export const DELETE_KPI_TYPE_SUCCESS = 'DELETE_KPI_TYPE_SUCCESS'
export const DELETE_KPI_TYPE_FAILED = 'DELETE_KPI_TYPE_FAILED'

export const FETCH_KPI_TYPE_FILTER_COMPANY_START = 'FETCH_KPI_TYPE_FILTER_COMPANY_START'
export const FETCH_KPI_TYPE_FILTER_COMPANY_SUCCESS = 'FETCH_KPI_TYPE_FILTER_COMPANY_SUCCESS'
export const FETCH_KPI_TYPE_FILTER_COMPANY_FAILED = 'FETCH_KPI_TYPE_FILTER_COMPANY_FAILED'

export const FETCH_KPI_TYPE_FILTER_KPI_TYPE_START = 'FETCH_KPI_TYPE_FILTER_KPI_TYPE_START'
export const FETCH_KPI_TYPE_FILTER_KPI_TYPE_SUCCESS = 'FETCH_KPI_TYPE_FILTER_KPI_TYPE_SUCCESS'
export const FETCH_KPI_TYPE_FILTER_KPI_TYPE_FAILED = 'FETCH_KPI_TYPE_FILTER_KPI_TYPE_FAILED'

// uom actions
export const FETCH_UOM_START = 'FETCH_UOM_START'
export const FETCH_UOM_SUCCESS = 'FETCH_UOM_SUCCESS'
export const FETCH_UOM_BY_ID_SUCCESS = 'FETCH_UOM_BY_ID_SUCCESS'
export const FETCH_UOM_FAILED = 'FETCH_UOM_FAILED'
export const CLEAR_SELECTED_UOM_RECORD = 'CLEAR_SELECTED_UOM_RECORD'

export const CREATE_UOM_START = 'CREATE_UOM_START'
export const CREATE_UOM_SUCCESS = 'CREATE_UOM_SUCCESS'
export const CREATE_UOM_FAILED = 'CREATE_UOM_FAILED'

export const UPDATE_UOM_START = 'UPDATE_UOM_START'
export const UPDATE_UOM_SUCCESS = 'UPDATE_UOM_SUCCESS'
export const UPDATE_UOM_FAILED = 'UPDATE_UOM_FAILED'

export const DELETE_UOM_START = 'DELETE_UOM_START'
export const DELETE_UOM_SUCCESS = 'DELETE_UOM_SUCCESS'
export const DELETE_UOM_FAILED = 'DELETE_UOM_FAILED'

export const FETCH_UOM_FILTER_COMPANY_START = 'FETCH_UOM_FILTER_COMPANY_START'
export const FETCH_UOM_FILTER_COMPANY_SUCCESS = 'FETCH_UOM_FILTER_COMPANY_SUCCESS'
export const FETCH_UOM_FILTER_COMPANY_FAILED = 'FETCH_UOM_FILTER_COMPANY_FAILED'

export const FETCH_UOM_FILTER_UOM_START = 'FETCH_UOM_FILTER_UOM_START'
export const FETCH_UOM_FILTER_UOM_SUCCESS = 'FETCH_UOM_FILTER_UOM_SUCCESS'
export const FETCH_UOM_FILTER_UOM_FAILED = 'FETCH_UOM_FILTER_UOM_FAILED'

// organization actions
export const FETCH_ORGANIZATION_START = 'FETCH_ORGANIZATION_START'
export const FETCH_ORGANIZATION_SUCCESS = 'FETCH_ORGANIZATION_SUCCESS'
export const FETCH_ORGANIZATION_BY_ID_SUCCESS = 'FETCH_ORGANIZATION_BY_ID_SUCCESS'
export const FETCH_ORGANIZATION_FAILED = 'FETCH_ORGANIZATION_FAILED'
export const CLEAR_SELECTED_ORGANIZATION_RECORD = 'CLEAR_SELECTED_ORGANIZATION_RECORD'

export const CREATE_ORGANIZATION_START = 'CREATE_ORGANIZATION_START'
export const CREATE_ORGANIZATION_SUCCESS = 'CREATE_ORGANIZATION_SUCCESS'
export const CREATE_ORGANIZATION_FAILED = 'CREATE_ORGANIZATION_FAILED'

export const UPDATE_ORGANIZATION_START = 'UPDATE_ORGANIZATION_START'
export const UPDATE_ORGANIZATION_SUCCESS = 'UPDATE_ORGANIZATION_SUCCESS'
export const UPDATE_ORGANIZATION_FAILED = 'UPDATE_ORGANIZATION_FAILED'

export const DELETE_ORGANIZATION_START = 'DELETE_ORGANIZATION_START'
export const DELETE_ORGANIZATION_SUCCESS = 'DELETE_ORGANIZATION_SUCCESS'
export const DELETE_ORGANIZATION_FAILED = 'DELETE_ORGANIZATION_FAILED'

export const IMPORT_ORG_START = 'IMPORT_ORG_START'
export const IMPORT_ORG_SUCCESS = 'IMPORT_ORG_SUCCESS'
export const IMPORT_ORG_FAILED = 'IMPORT_ORG_FAILED'

export const EXPORT_ORG_START = 'EXPORT_ORG_START'
export const EXPORT_ORG_SUCCESS = 'EXPORT_ORG_SUCCESS'
export const EXPORT_ORG_FAILED = 'EXPORT_ORG_FAILED'

export const DOWNLOAD_ORG_TEMPLATE_START = 'DOWNLOAD_ORG_TEMPLATE_START'
export const DOWNLOAD_ORG_TEMPLATE_SUCCESS = 'DOWNLOAD_ORG_TEMPLATE_SUCCESS'
export const DOWNLOAD_ORG_TEMPLATE_FAILED = 'DOWNLOAD_ORG_TEMPLATE_FAILED'

export const FETCH_PARENT_ORGANIZATION_LEVEL_OPTIONS_START =
  'FETCH_PARENT_ORGANIZATION_LEVEL_OPTIONS_START'
export const FETCH_PARENT_ORGANIZATION_LEVEL_OPTIONS_SUCCESS =
  'FETCH_PARENT_ORGANIZATION_LEVEL_OPTIONS_SUCCESS'
export const FETCH_PARENT_ORGANIZATION_LEVEL_OPTIONS_FAILED =
  'FETCH_PARENT_ORGANIZATION_LEVEL_OPTIONS_FAILED'

export const FETCH_ORGANIZATION_FILTER_COMPANY_START = 'FETCH_ORGANIZATION_FILTER_COMPANY_START'
export const FETCH_ORGANIZATION_FILTER_COMPANY_SUCCESS = 'FETCH_ORGANIZATION_FILTER_COMPANY_SUCCESS'
export const FETCH_ORGANIZATION_FILTER_COMPANY_FAILED = 'FETCH_ORGANIZATION_FILTER_COMPANY_FAILED'

export const FETCH_ORGANIZATION_FILTER_LEVEL_START = 'FETCH_ORGANIZATION_FILTER_LEVEL_START'
export const FETCH_ORGANIZATION_FILTER_LEVEL_SUCCESS = 'FETCH_ORGANIZATION_FILTER_LEVEL_SUCCESS'
export const FETCH_ORGANIZATION_FILTER_LEVEL_FAILED = 'FETCH_ORGANIZATION_FILTER_LEVEL_FAILED'

export const FETCH_ORGANIZATION_FILTER_ORGANIZATION_START =
  'FETCH_ORGANIZATION_FILTER_ORGANIZATION_START'
export const FETCH_ORGANIZATION_FILTER_ORGANIZATION_SUCCESS =
  'FETCH_ORGANIZATION_FILTER_ORGANIZATION_SUCCESS'
export const FETCH_ORGANIZATION_FILTER_ORGANIZATION_FAILED = 'FETCH_POSITION_FILTER_POSITION_FAILED'

export const FETCH_CRITERIA_START = 'FETCH_CRITERIA_START'
export const FETCH_CRITERIA_SUCCESS = 'FETCH_CRITERIA_SUCCESS'
export const FETCH_CRITERIA_BY_ID_SUCCESS = 'FETCH_CRITERIA_BY_ID_SUCCESS'
export const FETCH_CRITERIA_FAILED = 'FETCH_CRITERIA_FAILED'
export const CLEAR_SELECTED_CRITERIA_RECORD = 'CLEAR_SELECTED_CRITERIA_RECORD'

export const CREATE_CRITERIA_START = 'CREATE_CRITERIA_START'
export const CREATE_CRITERIA_SUCCESS = 'CREATE_CRITERIA_SUCCESS'
export const CREATE_CRITERIA_FAILED = 'CREATE_CRITERIA_FAILED'

export const UPDATE_CRITERIA_START = 'UPDATE_CRITERIA_START'
export const UPDATE_CRITERIA_SUCCESS = 'UPDATE_CRITERIA_SUCCESS'
export const UPDATE_CRITERIA_FAILED = 'UPDATE_CRITERIA_FAILED'

export const DELETE_CRITERIA_START = 'DELETE_CRITERIA_START'
export const DELETE_CRITERIA_SUCCESS = 'DELETE_CRITERIA_SUCCESS'
export const DELETE_CRITERIA_FAILED = 'DELETE_CRITERIA_FAILED'

export const FETCH_LEVEL_TABLE_START = 'FETCH_LEVEL_TABLE_START'
export const FETCH_LEVEL_TABLE_SUCCESS = 'FETCH_LEVEL_TABLE_SUCCESS'
export const FETCH_LEVEL_TABLE_FAILED = 'FETCH_LEVEL_TABLE_FAILED'

export const FETCH_CRITERIA_FILTER_COMPANY_START = 'FETCH_CRITERIA_FILTER_COMPANY_START'
export const FETCH_CRITERIA_FILTER_COMPANY_SUCCESS = 'FETCH_CRITERIA_FILTER_COMPANY_SUCCESS'
export const FETCH_CRITERIA_FILTER_COMPANY_FAILED = 'FETCH_CRITERIA_FILTER_COMPANY_FAILED'

export const FETCH_CRITERIA_FILTER_LEVEL_START = 'FETCH_CRITERIA_FILTER_LEVEL_START'
export const FETCH_CRITERIA_FILTER_LEVEL_SUCCESS = 'FETCH_CRITERIA_FILTER_LEVEL_SUCCESS'
export const FETCH_CRITERIA_FILTER_LEVEL_FAILED = 'FETCH_CRITERIA_FILTER_LEVEL_FAILED'

export const FETCH_CRITERIA_FILTER_CRITERIA_START = 'FETCH_CRITERIA_FILTER_CRITERIA_START'
export const FETCH_CRITERIA_FILTER_CRITERIA_SUCCESS = 'FETCH_CRITERIA_FILTER_CRITERIA_SUCCESS'
export const FETCH_CRITERIA_FILTER_CRITERIA_FAILED = 'FETCH_POSITION_FILTER_POSITION_FAILED'

// user actions
export const FETCH_USER_START = 'FETCH_USER_START'
export const FETCH_USER_SUCCESS = 'FETCH_USER_SUCCESS'
export const FETCH_USER_BY_ID_SUCCESS = 'FETCH_USER_BY_ID_SUCCESS'
export const FETCH_USER_FAILED = 'FETCH_USER_FAILED'
export const CLEAR_SELECTED_USER_RECORD = 'CLEAR_SELECTED_USER_RECORD'

export const CREATE_USER_START = 'CREATE_USER_START'
export const CREATE_USER_SUCCESS = 'CREATE_USER_SUCCESS'
export const CREATE_USER_FAILED = 'CREATE_USER_FAILED'

export const UPDATE_USER_START = 'UPDATE_USER_START'
export const UPDATE_USER_SUCCESS = 'UPDATE_USER_SUCCESS'
export const UPDATE_USER_FAILED = 'UPDATE_USER_FAILED'

export const DELETE_USER_START = 'DELETE_USER_START'
export const DELETE_USER_SUCCESS = 'DELETE_USER_SUCCESS'
export const DELETE_USER_FAILED = 'DELETE_USER_FAILED'

export const FETCH_USER_ROLE_OPTION_START = 'FETCH_USER_ROLE_OPTION_START'
export const FETCH_USER_ROLE_OPTION_SUCCESS = 'FETCH_USER_ROLE_OPTION_SUCCESS'
export const FETCH_USER_ROLE_OPTION_FAILED = 'FETCH_USER_ROLE_OPTION_FAILED'
// export const FETCH_PASSWORD_POLICY_OPTIONS_START = 'FETCH_PASSWORD_POLICY_OPTIONS_START'
// export const FETCH_PASSWORD_POLICY_OPTIONS_SUCCESS = 'FETCH_PASSWORD_POLICY_OPTIONS_SUCCESS'
// export const FETCH_PASSWORD_POLICY_OPTIONS_FAILED = 'FETCH_PASSWORD_POLICY_OPTIONS_FAILED'

// export const FETCH_LDAP_SERVER_OPTIONS_START = 'FETCH_LDAP_SERVER_OPTIONS_START'
// export const FETCH_LDAP_SERVER_OPTIONS_SUCCESS = 'FETCH_LDAP_SERVER_OPTIONS_SUCCESS'
// export const FETCH_LDAP_SERVER_OPTIONS_FAILED = 'FETCH_LDAP_SERVER_OPTIONS_FAILED'
export const FETCH_USER_FILTER_START = 'FETCH_USER_FILTER_START'
export const FETCH_USER_FILTER_SUCCESS = 'FETCH_USER_FILTER_SUCCESS'
export const FETCH_USER_FILTER_FAILED = 'FETCH_USER_FILTER_FAILED'
// appraisal Item actions
export const FETCH_APPRAISAL_ITEMS_START = 'FETCH_APPRAISAL_ITEMS_START'
export const FETCH_APPRAISAL_ITEMS_SUCCESS = 'FETCH_APPRAISAL_ITEMS_SUCCESS'
export const FETCH_APPRAISAL_ITEM_BY_ID_START = 'FETCH_APPRAISAL_ITEM_BY_ID_START'
export const FETCH_APPRAISAL_ITEM_BY_ID_SUCCESS = 'FETCH_APPRAISAL_ITEM_BY_ID_SUCCESS'
export const FETCH_APPRAISAL_ITEMS_FAILED = 'FETCH_APPRAISAL_ITEMS_FAILED'
export const CLEAR_SELECTED_APPRAISAL_ITEM_RECORD = 'CLEAR_SELECTED_APPRAISAL_ITEM_RECORD'

export const CREATE_APPRAISAL_ITEM_START = 'CREATE_APPRAISAL_ITEM_START'
export const CREATE_APPRAISAL_ITEM_SUCCESS = 'CREATE_APPRAISAL_ITEM_SUCCESS'
export const CREATE_APPRAISAL_ITEM_FAILED = 'CREATE_APPRAISAL_ITEM_FAILED'

export const UPDATE_APPRAISAL_ITEM_START = 'UPDATE_APPRAISAL_ITEM_START'
export const UPDATE_APPRAISAL_ITEM_SUCCESS = 'UPDATE_APPRAISAL_ITEM_SUCCESS'
export const UPDATE_APPRAISAL_ITEM_FAILED = 'UPDATE_APPRAISAL_ITEM_FAILED'

export const DELETE_APPRAISAL_ITEM_START = 'DELETE_APPRAISAL_ITEM_START'
export const DELETE_APPRAISAL_ITEM_SUCCESS = 'DELETE_APPRAISAL_ITEM_SUCCESS'
export const DELETE_APPRAISAL_ITEM_FAILED = 'DELETE_APPRAISAL_ITEM_FAILED'

export const IMPORT_APPRAISAL_ITEMS_START = 'IMPORT_APPRAISAL_ITEMS_START'
export const IMPORT_APPRAISAL_ITEMS_SUCCESS = 'IMPORT_APPRAISAL_ITEMS_SUCCESS'
export const IMPORT_APPRAISAL_ITEMS_FAILED = 'IMPORT_APPRAISAL_ITEMS_FAILED'

export const EXPORT_APPRAISAL_ITEMS_START = 'EXPORT_APPRAISAL_ITEMS_START'
export const EXPORT_APPRAISAL_ITEMS_SUCCESS = 'EXPORT_APPRAISAL_ITEMS_SUCCESS'
export const EXPORT_APPRAISAL_ITEMS_FAILED = 'EXPORT_APPRAISAL_ITEMS_FAILED'

export const DOWNLOAD_APPRAISAL_ITEM_TEMPLATE_START = 'DOWNLOAD_APPRAISAL_ITEM_TEMPLATE_START'
export const DOWNLOAD_APPRAISAL_ITEM_TEMPLATE_SUCCESS = 'DOWNLOAD_APPRAISAL_ITEM_TEMPLATE_SUCCESS'
export const DOWNLOAD_APPRAISAL_ITEM_TEMPLATE_FAILED = 'DOWNLOAD_APPRAISAL_ITEM_TEMPLATE_FAILED'

// Auth actions
export const SIGNIN_START = 'SIGNIN_START'
export const SIGNIN_SUCCESS = 'SIGNIN_SUCCESS'
export const SIGNIN_FAILED = 'SIGNIN_FAILED'

export const FORGOTPASS_START = 'FORGOTPASS_START'
export const FORGOTPASS_SUCCESS = 'FORGOTPASS_SUCCESS'
export const FORGOTPASS_FAILED = 'FORGOTPASS_FAILED'

export const SIGNOUT_START = 'SIGNOUT_START'
export const SIGNOUT_SUCCESS = 'SIGNOUT_SUCCESS'
export const SIGNOUT_FAILED = 'SIGNOUT_FAILED'

// Employee actions
export const FETCH_ORGANIZATION_OPTIONS_FOR_EMPLOYEE_START =
  'FETCH_ORGANIZATION_OPTIONS_FOR_EMPLOYEE_START'
export const FETCH_ORGANIZATION_OPTIONS_FOR_EMPLOYEE_SUCCESS =
  'FETCH_ORGANIZATION_OPTIONS_FOR_EMPLOYEE_SUCCESS'
export const FETCH_ORGANIZATION_OPTIONS_FOR_EMPLOYEE_FAILED =
  'FETCH_ORGANIZATION_OPTIONS_FOR_EMPLOYEE_FAILED'
export const FETCH_EMPLOYEE_START = 'FETCH_EMPLOYEE_START'
export const FETCH_EMPLOYEE_SUCCESS = 'FETCH_EMPLOYEE_SUCCESS'
export const FETCH_EMPLOYEE_BY_ID_SUCCESS = 'FETCH_EMPLOYEE_BY_ID_SUCCESS'
export const FETCH_EMPLOYEE_FAILED = 'FETCH_EMPLOYEE_FAILED'
export const CLEAR_SELECTED_EMPLOYEE_RECORD = 'CLEAR_SELECTED_EMPLOYEE_RECORD'

export const CREATE_EMPLOYEE_START = 'CREATE_EMPLOYEE_START'
export const CREATE_EMPLOYEE_SUCCESS = 'CREATE_EMPLOYEE_SUCCESS'
export const CREATE_EMPLOYEE_FAILED = 'CREATE_EMPLOYEE_FAILED'

export const UPDATE_EMPLOYEE_START = 'UPDATE_EMPLOYEE_START'
export const UPDATE_EMPLOYEE_SUCCESS = 'UPDATE_EMPLOYEE_SUCCESS'
export const UPDATE_EMPLOYEE_FAILED = 'UPDATE_EMPLOYEE_FAILED'

export const DELETE_EMPLOYEE_START = 'DELETE_EMPLOYEE_START'
export const DELETE_EMPLOYEE_SUCCESS = 'DELETE_EMPLOYEE_SUCCESS'
export const DELETE_EMPLOYEE_FAILED = 'DELETE_EMPLOYEE_FAILED'

export const IMPORT_EMPLOYEE_START = 'IMPORT_EMPLOYEE_START'
export const IMPORT_EMPLOYEE_SUCCESS = 'IMPORT_EMPLOYEE_SUCCESS'
export const IMPORT_EMPLOYEE_FAILED = 'IMPORT_EMPLOYEE_FAILED'

export const EXPORT_EMPLOYEE_START = 'EXPORT_EMPLOYEE_START'
export const EXPORT_EMPLOYEE_SUCCESS = 'EXPORT_EMPLOYEE_SUCCESS'
export const EXPORT_EMPLOYEE_FAILED = 'EXPORT_EMPLOYEE_FAILED'

export const DOWNLOAD_EMPLOYEE_TEMPLATE_START = 'DOWNLOAD_EMPLOYEE_TEMPLATE_START'
export const DOWNLOAD_EMPLOYEE_TEMPLATE_SUCCESS = 'DOWNLOAD_EMPLOYEE_TEMPLATE_SUCCESS'
export const DOWNLOAD_EMPLOYEE_TEMPLATE_FAILED = 'DOWNLOAD_EMPLOYEE_TEMPLATE_FAILED'

export const ENQUEUE_SNACKBAR = 'ENQUEUE_SNACKBAR'
export const CLOSE_SNACKBAR = 'CLOSE_SNACKBAR'
export const REMOVE_SNACKBAR = 'REMOVE_SNACKBAR'

// Assignment actions
export const FETCH_ASSIGNMENT_DATA_START = 'FETCH_ASSIGNMENT_DATA_START'
export const FETCH_ASSIGNMENT_DATA_SUCCESS = 'FETCH_ASSIGNMENT_DATA_SUCCESS'
export const FETCH_ASSIGNMENT_DATA_FAILED = 'FETCH_ASSIGNMENT_DATA_FAILED'

export const ASSIGNMENT_SET_ASSIGN_FILTER = 'ASSIGNMENT_SET_ASSIGN_FILTER'
export const ASSIGNMENT_SET_ASSIGN_TARGET = 'ASSIGNMENT_SET_ASSIGN_TARGET'
export const ASSIGNMENT_SET_ASSIGN_ITEMS = 'ASSIGNMENT_SET_ASSIGN_ITEMS'
export const ASSIGNMENT_SET_ASSIGN_ACTION = 'ASSIGNMENT_SET_ASSIGN_ACTION'
export const ASSIGNMENT_SET_ASSIGN_DATA = 'ASSIGNMENT_SET_ASSIGN_DATA'
export const ASSIGNMENT_CLEAR_ASSIGN_ITEMS = 'ASSIGNMENT_CLEAR_ASSIGN_ITEMS'
export const ASSIGNMENT_SAVE_DRAFT = 'ASSIGNMENT_SAVE_DRAFT'

export const ASSIGNMENT_SAVE_ASSIGN_START = 'ASSIGNMENT_SAVE_ASSIGN_START'
export const ASSIGNMENT_SAVE_ASSIGN_SUCCESS = 'ASSIGNMENT_SAVE_ASSIGN_SUCCESS'
export const ASSIGNMENT_SAVE_ASSIGN_FAILED = 'ASSIGNMENT_SAVE_ASSIGN_FAILED'

export const ASSIGNMENT_UPDATE_ASSIGN_START = 'ASSIGNMENT_UPDATE_ASSIGN_START'
export const ASSIGNMENT_UPDATE_ASSIGN_SUCCESS = 'ASSIGNMENT_UPDATE_ASSIGN_SUCCESS'
export const ASSIGNMENT_UPDATE_ASSIGN_FAILED = 'ASSIGNMENT_UPDATE_ASSIGN_FAILED'

export const ASSIGNMENT_DELETE_ASSIGN_START = 'ASSIGNMENT_DELETE_ASSIGN_START'
export const ASSIGNMENT_DELETE_ASSIGN_SUCCESS = 'ASSIGNMENT_DELETE_ASSIGN_SUCCESS'
export const ASSIGNMENT_DELETE_ASSIGN_FAILED = 'ASSIGNMENT_DELETE_ASSIGN_FAILED'

export const ASSIGNMENT_FETCH_BY_ID_START = 'ASSIGNMENT_FETCH_BY_ID_START'
export const ASSIGNMENT_FETCH_BY_ID_SUCCESS = 'ASSIGNMENT_FETCH_BY_ID_SUCCESS'
export const ASSIGNMENT_FETCH_BY_ID_FAILED = 'ASSIGNMENT_FETCH_BY_ID_FAILED'

export const FETCH_ASSIGNMENT_DATA_TEMPLATE_START = 'FETCH_ASSIGNMENT_DATA_TEMPLATE_START'
export const FETCH_ASSIGNMENT_DATA_TEMPLATE_SUCCESS = 'FETCH_ASSIGNMENT_DATA_TEMPLATE_SUCCESS'
export const FETCH_ASSIGNMENT_DATA_TEMPLATE_FAILED = 'FETCH_ASSIGNMENT_DATA_TEMPLATE_FAILED'

export const FETCH_APPRAISAL_STRUCTURES_START = 'FETCH_APPRAISAL_STRUCTURES_START'
export const FETCH_APPRAISAL_STRUCTURES_SUCCESS = 'FETCH_APPRAISAL_STRUCTURES_SUCCESS'
export const FETCH_APPRAISAL_STRUCTURES_FAILED = 'FETCH_APPRAISAL_STRUCTURES_FAILED'

export const IMPORT_ASSIGNMENT_START = 'IMPORT_ASSIGNMENT_START'
export const IMPORT_ASSIGNMENT_SUCCESS = 'IMPORT_ASSIGNMENT_SUCCESS'
export const IMPORT_ASSIGNMENT_FAILED = 'IMPORT_ASSIGNMENT_FAILED'

export const EXPORT_ASSIGNMENT_START = 'EXPORT_ASSIGNMENT_START'
export const EXPORT_ASSIGNMENT_SUCCESS = 'EXPORT_ASSIGNMENT_SUCCESS'
export const EXPORT_ASSIGNMENT_FAILED = 'EXPORT_ASSIGNMENT_FAILED'

export const DOWNLOAD_ASSIGNMENT_TEMPLATE_START = 'DOWNLOAD_ASSIGNMENT_TEMPLATE_START'
export const DOWNLOAD_ASSIGNMENT_TEMPLATE_SUCCESS = 'DOWNLOAD_ASSIGNMENT_TEMPLATE_SUCCESS'
export const DOWNLOAD_ASSIGNMENT_TEMPLATE_FAILED = 'DOWNLOAD_ASSIGNMENT_TEMPLATE_FAILED'

export const COPY_ASSIGNMENT_START = 'COPY_ASSIGNMENT_START'
export const COPY_ASSIGNMENT_SUCCESS = 'COPY_ASSIGNMENT_SUCCESS'
export const COPY_ASSIGNMENT_FAILED = 'COPY_ASSIGNMENT_FAILED'

export const CLEAR_FILTERED_ASSIGNMENT_RECORDS = 'CLEAR_FILTERED_ASSIGNMENT_RECORDS'

export const BULK_DELETE_ASSIGNMENT_START = 'BULK_DELETE_ASSIGNMENT_START'
export const BULK_DELETE_ASSIGNMENT_SUCCESS = 'BULK_DELETE_ASSIGNMENT_SUCCESS'
export const BULK_DELETE_ASSIGNMENT_FAILED = 'BULK_DELETE_ASSIGNMENT_FAILED'

export const BULK_UPDATE_ASSIGNMENT_START = 'BULK_UPDATE_ASSIGNMENT_START'
export const BULK_UPDATE_ASSIGNMENT_SUCCESS = 'BULK_UPDATE_ASSIGNMENT_SUCCESS'
export const BULK_UPDATE_ASSIGNMENT_FAILED = 'BULK_UPDATE_ASSIGNMENT_FAILED'

// Adjust actions
export const UPDATE_PROFILE_START = 'UPDATE_PROFILE_START'
export const UPDATE_PROFILE_SUCCESS = 'UPDATE_PROFILE_SUCCESS'
export const UPDATE_PROFILE_FAILED = 'UPDATE_PROFILE_FAILED'

export const EXPORT_ADJUST_START = 'EXPORT_ADJUST_START'
export const EXPORT_ADJUST_SUCCESS = 'EXPORT_ADJUST_SUCCESS'
export const EXPORT_ADJUST_FAILED = 'EXPORT_ADJUST_FAILED'

// Appraisal actions
export const FETCH_APPRAISAL_DATA_START = 'FETCH_APPRAISAL_DATA_START'
export const FETCH_APPRAISAL_DATA_SUCCESS = 'FETCH_APPRAISAL_DATA_SUCCESS'
export const FETCH_APPRAISAL_DATA_FAILED = 'FETCH_APPRAISAL_DATA_FAILED'

export const FETCH_APPRAISAL_RESULT_START = 'FETCH_APPRAISAL_RESULT_START'
export const FETCH_APPRAISAL_RESULT_SUCCESS = 'FETCH_APPRAISAL_RESULT_SUCCESS'
export const FETCH_APPRAISAL_RESULT_FAILED = 'FETCH_APPRAISAL_RESULT_FAILED'

export const APPRAISAL_SAVE_START = 'APPRAISAL_SAVE_START'
export const APPRAISAL_SAVE_SUCCESS = 'APPRAISAL_SAVE_SUCCESS'
export const APPRAISAL_SAVE_FAILED = 'APPRAISAL_SAVE_FAILED'

export const IMPORT_APPRAISAL_START = 'IMPORT_APPRAISAL_START'
export const IMPORT_APPRAISAL_SUCCESS = 'IMPORT_APPRAISAL_SUCCESS'
export const IMPORT_APPRAISAL_FAILED = 'IMPORT_APPRAISAL_FAILED'

export const EXPORT_APPRAISAL_START = 'EXPORT_APPRAISAL_START'
export const EXPORT_APPRAISAL_SUCCESS = 'EXPORT_APPRAISAL_SUCCESS'
export const EXPORT_APPRAISAL_FAILED = 'EXPORT_APPRAISAL_FAILED'

export const DOWNLOAD_APPRAISAL_TEMPLATE_START = 'DOWNLOAD_APPRAISAL_TEMPLATE_START'
export const DOWNLOAD_APPRAISAL_TEMPLATE_SUCCESS = 'DOWNLOAD_APPRAISAL_TEMPLATE_SUCCESS'
export const DOWNLOAD_APPRAISAL_TEMPLATE_FAILED = 'DOWNLOAD_APPRAISAL_TEMPLATE_FAILED'

export const SET_APPRAISAL_FILTER = 'SET_APPRAISAL_FILTER'
export const CLEAR_FILTERED_APPRAISAL_RECORDS = 'CLEAR_FILTERED_APPRAISAL_RECORDS'
export const CLEAR_SELECTED_APPRAISAL_DATA = 'CLEAR_SELECTED_APPRAISAL_DATA'

export const FETCH_APPRAISAL_COMMENT_START = 'FETCH_APPRAISAL_COMMENT_START'
export const FETCH_APPRAISAL_COMMENT_SUCCESS = 'FETCH_APPRAISAL_COMMENT_SUCCESS'
export const FETCH_APPRAISAL_COMMENT_FAILED = 'FETCH_APPRAISAL_COMMENT_FAILED'

export const POST_APPRAISAL_COMMENT_START = 'POST_APPRAISAL_COMMENT_START'
export const POST_APPRAISAL_COMMENT_SUCCESS = 'POST_APPRAISAL_COMMENT_SUCCESS'
export const POST_APPRAISAL_COMMENT_FAILED = 'POST_APPRAISAL_COMMENT_FAILED'

export const DELETE_APPRAISAL_COMMENT_START = 'DELETE_APPRAISAL_COMMENT_START'
export const DELETE_APPRAISAL_COMMENT_SUCCESS = 'DELETE_APPRAISAL_COMMENT_SUCCESS'
export const DELETE_APPRAISAL_COMMENT_FAILED = 'DELETE_APPRAISAL_COMMENT_FAILED'

export const APPRAISAL_SET_GANTT_CHART = 'APPRAISAL_SET_GANTT_CHART'

export const FETCH_TO_STAGE_START = 'FETCH_TO_STAGE_START'
export const FETCH_TO_STAGE_SUCCESS = 'FETCH_TO_STAGE_SUCCESS'
export const FETCH_TO_STAGE_FAILED = 'FETCH_TO_STAGE_FAILED'

export const BULK_UPDATE_APPRAISAL_START = 'BULK_UPDATE_APPRAISAL_START'
export const BULK_UPDATE_APPRAISAL_SUCCESS = 'BULK_UPDATE_APPRAISAL_SUCCESS'
export const BULK_UPDATE_APPRAISAL_FAILED = 'BULK_UPDATE_APPRAISAL_FAILED'

export const SAVE_ACTION_TO_START = 'SAVE_ACTION_TO_START'
export const SAVE_ACTION_TO_SUCCESS = 'SAVE_ACTION_TO_SUCCESS'
export const SAVE_ACTION_TO_FAILED = 'SAVE_ACTION_TO_FAILED'

export const FETCH_ACTION_PLAN_START = 'FETCH_ACTION_PLAN_START'
export const FETCH_ACTION_PLAN_SUCCESS = 'FETCH_ACTION_PLAN_SUCCESS'
export const FETCH_ACTION_PLAN_FAILED = 'FETCH_ACTION_PLAN_FAILED'

export const SAVE_ACTION_PLAN_START = 'SAVE_ACTION_PLAN_START'
export const SAVE_ACTION_PLAN_SUCCESS = 'SAVE_ACTION_PLAN_SUCCESS'
export const SAVE_ACTION_PLAN_FAILED = 'SAVE_ACTION_PLAN_FAILED'

export const APPRAISAL_SUM_UP_START = 'APPRAISAL_SUM_UP_START'
export const APPRAISAL_SUM_UP_SUCCESS = 'APPRAISAL_SUM_UP_SUCCESS'
export const APPRAISAL_SUM_UP_FAILED = 'APPRAISAL_SUM_UP_FAILED'

//
export const FETCH_THRESHOLD_GROUP_START = 'FETCH_THRESHOLD_GROUP_START'
export const FETCH_THRESHOLD_GROUP_SUCCESS = 'FETCH_THRESHOLD_GROUP_SUCCESS'
export const FETCH_THRESHOLD_GROUP_FAILED = 'FETCH_THRESHOLD_GROUP_FAILED'

export const CREATE_THRESHOLD_GROUP_START = 'CREATE_THRESHOLD_GROUP_START'
export const CREATE_THRESHOLD_GROUP_SUCCESS = 'CREATE_THRESHOLD_GROUP_SUCCESS'
export const CREATE_THRESHOLD_GROUP_FAILED = 'CREATE_THRESHOLD_GROUP_FAILED'

export const FETCH_THRESHOLD_GROUP_FILTER_THRESHOLD_GROUP_START =
  'FETCH_THRESHOLD_GROUP_FILTER_THRESHOLD_GROUP_START'
export const FETCH_THRESHOLD_GROUP_FILTER_THRESHOLD_GROUP_SUCCESS =
  'FETCH_THRESHOLD_GROUP_FILTER_THRESHOLD_GROUP_SUCCESS'
export const FETCH_THRESHOLD_GROUP_FILTER_THRESHOLD_GROUP_FAILED =
  'FETCH_THRESHOLD_GROUP_FILTER_THRESHOLD_GROUP_FAILED'

export const UPDATE_THRESHOLD_GROUP_START = 'UPDATE_THRESHOLD_GROUP_START'
export const UPDATE_THRESHOLD_GROUP_SUCCESS = 'UPDATE_THRESHOLD_GROUP_SUCCESS'
export const UPDATE_THRESHOLD_GROUP_FAILED = 'UPDATE_THRESHOLD_GROUP_FAILED'

export const DELETE_THRESHOLD_GROUP_START = 'DELETE_THRESHOLD_GROUP_START'
export const DELETE_THRESHOLD_GROUP_SUCCESS = 'DELETE_THRESHOLD_GROUP_SUCCESS'
export const DELETE_THRESHOLD_GROUP_FAILED = 'DELETE_THRESHOLD_GROUP_FAILED'

export const FETCH_THRESHOLD_GROUP_BY_ID_SUCCESS = 'FETCH_THRESHOLD_GROUP_BY_ID_SUCCESS'
export const CLEAR_SELECTED_THRESHOLD_GROUP_RECORD = 'CLEAR_SELECTED_THRESHOLD_GROUP_RECORD'

export const FETCH_USAGE_LOG_START = 'FETCH_USAGE_LOG_START'
export const FETCH_USAGE_LOG_SUCCESS = 'FETCH_USAGE_LOG_SUCCESS'
export const FETCH_USAGE_LOG_FAILED = 'FETCH_USAGE_LOG_FAILED'
export const FETCH_LEVEL_GROUP_FILTER_APPRAISAL_START = 'FETCH_LEVEL_GROUP_FILTER_APPRAISAL_START'
export const FETCH_LEVEL_GROUP_FILTER_APPRAISAL_SUCCESS =
  'FETCH_LEVEL_GROUP_FILTER_APPRAISAL_SUCCESS'
export const FETCH_LEVEL_GROUP_FILTER_APPRAISAL_FAILED = 'FETCH_LEVEL_GROUP_FILTER_APPRAISAL_FAILED'

export const FETCH_DASHBOARD_OVERALL_PERFORMANCE_START = 'FETCH_DASHBOARD_OVERALL_PERFORMANCE_START'
export const FETCH_DASHBOARD_OVERALL_PERFORMANCE_SUCCESS =
  'FETCH_DASHBOARD_OVERALL_PERFORMANCE_SUCCESS'
export const FETCH_DASHBOARD_OVERALL_PERFORMANCE_FAILED =
  'FETCH_DASHBOARD_OVERALL_PERFORMANCE_FAILED'
export const CLEAR_SELECTED_DASHBOARD_OVERALL_PERFORMANCE_RECORD =
  'CLEAR_SELECTED_DASHBOARD_OVERALL_PERFORMANCE_RECORD'

// DASHBOARD_PERFORMANCE_COMPARISON

// CHART_LINE
export const FETCH_DASHBOARD_PERFORMANCE_COMPARISON_CHART_LINE_START =
  'FETCH_DASHBOARD_PERFORMANCE_COMPARISON_CHART_LINE_START'
export const FETCH_DASHBOARD_PERFORMANCE_COMPARISON_CHART_LINE_SUCCESS =
  'FETCH_DASHBOARD_PERFORMANCE_COMPARISON_CHART_LINE_SUCCESS'
export const FETCH_DASHBOARD_PERFORMANCE_COMPARISON_CHART_LINE_FAILED =
  'FETCH_DASHBOARD_PERFORMANCE_COMPARISON_CHART_LINE_FAILED'

// CHART_BAR
export const FETCH_DASHBOARD_PERFORMANCE_COMPARISON_CHART_BAR_START =
  'FETCH_DASHBOARD_PERFORMANCE_COMPARISON_CHART_BAR_START'
export const FETCH_DASHBOARD_PERFORMANCE_COMPARISON_CHART_BAR_SUCCESS =
  'FETCH_DASHBOARD_PERFORMANCE_COMPARISON_CHART_BAR_SUCCESS'
export const FETCH_DASHBOARD_PERFORMANCE_COMPARISON_CHART_BAR_FAILED =
  'FETCH_DASHBOARD_PERFORMANCE_COMPARISON_CHART_BAR_FAILED'

// DATA_KPI
export const FETCH_DASHBOARD_PERFORMANCE_COMPARISON_DATA_KPI_START =
  'FETCH_DASHBOARD_PERFORMANCE_COMPARISON_DATA_KPI_START'
export const FETCH_DASHBOARD_PERFORMANCE_COMPARISON_DATA_KPI_SUCCESS =
  'FETCH_DASHBOARD_PERFORMANCE_COMPARISON_DATA_KPI_SUCCESS'
export const FETCH_DASHBOARD_PERFORMANCE_COMPARISON_DATA_KPI_FAILED =
  'FETCH_DASHBOARD_PERFORMANCE_COMPARISON_DATA_KPI_FAILED'

// DASHBOARD_PERFORMANCE_TREND

// STRUCTURE
export const FETCH_STRUCTURE_OPTION_FOR_PERFORMANCE_TREND_START =
  'FETCH_STRUCTURE_OPTION_FOR_PERFORMANCE_TREND_START'
export const FETCH_STRUCTURE_OPTION_FOR_PERFORMANCE_TREND_SUCCESS =
  'FETCH_STRUCTURE_OPTION_FOR_PERFORMANCE_TREND_SUCCESS'
export const FETCH_STRUCTURE_OPTION_FOR_PERFORMANCE_TREND_FAILED =
  'FETCH_STRUCTURE_OPTION_FOR_PERFORMANCE_TREND_FAILED'

// ITEM
export const FETCH_ITEM_OPTIONS_FOR_PERFORMANCE_TREND_START =
  'FETCH_ITEM_OPTIONS_FOR_PERFORMANCE_TREND_START'
export const FETCH_ITEM_OPTIONS_FOR_PERFORMANCE_TREND_SUCCESS =
  'FETCH_ITEM_OPTIONS_FOR_PERFORMANCE_TREND_SUCCESS'
export const FETCH_ITEM_OPTIONS_FOR_PERFORMANCE_TREND_FAILED =
  'FETCH_ITEM_OPTIONS_FOR_PERFORMANCE_TREND_FAILED'

// CHART
export const FETCH_DASHBOARD_PERFORMANCE_TREND_CHART_START =
  'FETCH_DASHBOARD_PERFORMANCE_TREND_CHART_START'
export const FETCH_DASHBOARD_PERFORMANCE_TREND_CHART_SUCCESS =
  'FETCH_DASHBOARD_PERFORMANCE_TREND_CHART_SUCCESS'
export const FETCH_DASHBOARD_PERFORMANCE_TREND_CHART_FAILED =
  'FETCH_DASHBOARD_PERFORMANCE_TREND_CHART_FAILED'

// ALL
export const FETCH_DASHBOARD_PERFORMANCE_TREND_ALL_START =
  'FETCH_DASHBOARD_PERFORMANCE_TREND_ALL_START'
export const FETCH_DASHBOARD_PERFORMANCE_TREND_ALL_SUCCESS =
  'FETCH_DASHBOARD_PERFORMANCE_TREND_ALL_SUCCESS'
export const FETCH_DASHBOARD_PERFORMANCE_TREND_ALL_FAILED =
  'FETCH_DASHBOARD_PERFORMANCE_TREND_ALL_FAILED'

// FETCH_EMPLOYEE_DETAIL_OPTIONS
export const FETCH_EMPLOYEE_DETAIL_OPTIONS_START = 'FETCH_EMPLOYEE_DETAIL_OPTIONS_START'
export const FETCH_EMPLOYEE_DETAIL_OPTIONS_SUCCESS = 'FETCH_EMPLOYEE_DETAIL_OPTIONS_SUCCESS'
export const FETCH_EMPLOYEE_DETAIL_OPTIONS_FAILED = 'FETCH_EMPLOYEE_DETAIL_OPTIONS_FAILED'

export const REPORT_APPRASAL_SUMMARY_START = 'REPORT_APPRASAL_SUMMARY_START'
export const REPORT_APPRASAL_SUMMARY_SUCCESS = 'REPORT_APPRASAL_SUMMARY_SUCCESS'
export const REPORT_APPRASAL_SUMMARY_FAILED = 'REPORT_APPRASAL_SUMMARY_FAILED'
export const CLEAR_REPORT_APPRASAL_SUMMARY = 'CLEAR_REPORT_APPRASAL_SUMMARY'

export const REPORT_DATA_ENTRY_START = 'REPORT_DATA_ENTRY_START'
export const REPORT_DATA_ENTRY_SUCCESS = 'REPORT_DATA_ENTRY_SUCCESS'
export const REPORT_DATA_ENTRY_FAILED = 'REPORT_DATA_ENTRY_FAILED'
export const CLEAR_REPORT_DATA_ENTRY = 'CLEAR_REPORT_DATA_ENTRY'

export const REPORT_KPI_START = 'REPORT_KPI_START'
export const REPORT_KPI_SUCCESS = 'REPORT_KPI_SUCCESS'
export const REPORT_KPI_FAILED = 'REPORT_KPI_FAILED'
export const CLEAR_REPORT_KPI = 'CLEAR_REPORT_KPI'

export const REPORT_PERFORMANCE_FORM_START = 'REPORT_PERFORMANCE_FORM_START'
export const REPORT_PERFORMANCE_FORM_SUCCESS = 'REPORT_PERFORMANCE_FORM_SUCCESS'
export const REPORT_PERFORMANCE_FORM_FAILED = 'REPORT_PERFORMANCE_FORM_FAILED'
export const CLEAR_REPORT_PERFORMANCE_FORM = 'CLEAR_REPORT_PERFORMANCE_FORM'

export const FETCH_ORGANIZATION_CHANNEL_OPTIONS_START = 'FETCH_ORGANIZATION_CHANNEL_OPTIONS_START'
export const FETCH_ORGANIZATION_CHANNEL_OPTIONS_SUCCESS =
  'FETCH_ORGANIZATION_CHANNEL_OPTIONS_SUCCESS'
export const FETCH_ORGANIZATION_CHANNEL_OPTIONS_FAILED = 'FETCH_ORGANIZATION_CHANNEL_OPTIONS_FAILED'

export const FETCH_PROVINCE_OPTIONS_START = 'FETCH_PROVINCE_OPTIONS_START'
export const FETCH_PROVINCE_OPTIONS_SUCCESS = 'FETCH_PROVINCE_OPTIONS_SUCCESS'
export const FETCH_PROVINCE_OPTIONS_FAILED = 'FETCH_PROVINCE_OPTIONS_FAILED'

export const DASHBOARD_BRANCH_PERFORMANCE_START = 'DASHBOARD_BRANCH_PERFORMANCE_START'
export const DASHBOARD_BRANCH_PERFORMANCE_SUCCESS = 'DASHBOARD_BRANCH_PERFORMANCE_SUCCESS'
export const DASHBOARD_BRANCH_PERFORMANCE_FAILED = 'DASHBOARD_BRANCH_PERFORMANCE_FAILED'
export const CLEAR_DASHBOARD_BRANCH_PERFORMANCE = 'CLEAR_DASHBOARD_BRANCH_PERFORMANCE'
export const DASHBOARD_BRANCH_PERFORMANCE_DETAIL_START = 'DASHBOARD_BRANCH_PERFORMANCE_DETAIL_START'
export const DASHBOARD_BRANCH_PERFORMANCE_DETAIL_SUCCESS =
  'DASHBOARD_BRANCH_PERFORMANCE_DETAIL_SUCCESS'
export const DASHBOARD_BRANCH_PERFORMANCE_DETAIL_FAILED =
  'DASHBOARD_BRANCH_PERFORMANCE_DETAIL_FAILED'

export const FETCH_FORCE_RANK_GROUP_START = 'FETCH_FORCE_RANK_GROUP_START'
export const FETCH_FORCE_RANK_GROUP_SUCCESS = 'FETCH_FORCE_RANK_GROUP_SUCCESS'
export const FETCH_FORCE_RANK_GROUP_BY_ID_SUCCESS = 'FETCH_FORCE_RANK_GROUP_BY_ID_SUCCESS'
export const FETCH_FORCE_RANK_GROUP_FAILED = 'FETCH_FORCE_RANK_GROUP_FAILED'
export const CLEAR_SELECTED_FORCE_RANK_GROUP_RECORD = 'CLEAR_SELECTED_FORCE_RANK_GROUP_RECORD'

export const CREATE_FORCE_RANK_GROUP_START = 'CREATE_FORCE_RANK_GROUP_START'
export const CREATE_FORCE_RANK_GROUP_SUCCESS = 'CREATE_FORCE_RANK_GROUP_SUCCESS'
export const CREATE_FORCE_RANK_GROUP_FAILED = 'CREATE_FORCE_RANK_GROUP_FAILED'

export const UPDATE_FORCE_RANK_GROUP_START = 'UPDATE_FORCE_RANK_GROUP_START'
export const UPDATE_FORCE_RANK_GROUP_SUCCESS = 'UPDATE_FORCE_RANK_GROUP_SUCCESS'
export const UPDATE_FORCE_RANK_GROUP_FAILED = 'UPDATE_FORCE_RANK_GROUP_FAILED'

export const DELETE_FORCE_RANK_GROUP_START = 'DELETE_FORCE_RANK_GROUP_START'
export const DELETE_FORCE_RANK_GROUP_SUCCESS = 'DELETE_FORCE_RANK_GROUP_SUCCESS'
export const DELETE_FORCE_RANK_GROUP_FAILED = 'DELETE_FORCE_RANK_GROUP_FAILED'

export const FETCH_FORCE_RANK_GROUP_FILTER_FORCE_RANK_GROUP_START =
  'FETCH_FORCE_RANK_GROUP_FILTER_FORCE_RANK_GROUP_START'
export const FETCH_FORCE_RANK_GROUP_FILTER_FORCE_RANK_GROUP_SUCCESS =
  'FETCH_FORCE_RANK_GROUP_FILTER_FORCE_RANK_GROUP_SUCCESS'
export const FETCH_FORCE_RANK_GROUP_FILTER_FORCE_RANK_GROUP_FAILED =
  'FETCH_FORCE_RANK_GROUP_FILTER_FORCE_RANK_GROUP_FAILED'

export const REPORT_APPRAISAL_BY_ORG_START = 'REPORT_APPRAISAL_BY_ORG_START'
export const REPORT_APPRAISAL_BY_ORG_SUCCESS = 'REPORT_APPRAISAL_BY_ORG_SUCCESS'
export const REPORT_APPRAISAL_BY_ORG_FAILED = 'REPORT_APPRAISAL_BY_ORG_FAILED'
export const CLEAR_REPORT_APPRAISAL_BY_ORG = 'CLEAR_REPORT_APPRAISAL_BY_ORG'

export const REPORT_APPRAISAL_BY_LEVEL_START = 'REPORT_APPRAISAL_BY_LEVEL_START'
export const REPORT_APPRAISAL_BY_LEVEL_SUCCESS = 'REPORT_APPRAISAL_BY_LEVEL_SUCCESS'
export const REPORT_APPRAISAL_BY_LEVEL_FAILED = 'REPORT_APPRAISAL_BY_LEVEL_FAILED'
export const CLEAR_REPORT_APPRAISAL_BY_LEVEL = 'CLEAR_REPORT_APPRAISAL_BY_LEVEL'

export const REPORT_APPRAISAL_BY_JOB_KPI_START = 'REPORT_APPRAISAL_BY_JOB_KPI_START'
export const REPORT_APPRAISAL_BY_JOB_KPI_SUCCESS = 'REPORT_APPRAISAL_BY_JOB_KPI_SUCCESS'
export const REPORT_APPRAISAL_BY_JOB_KPI_FAILED = 'REPORT_APPRAISAL_BY_JOB_KPI_FAILED'
export const CLEAR_REPORT_APPRAISAL_BY_JOB_KPI = 'CLEAR_REPORT_APPRAISAL_BY_JOB_KPI'

export const REPORT_BONUS_SALARY_START = 'REPORT_BONUS_SALARY_START'
export const REPORT_BONUS_SALARY_SUCCESS = 'REPORT_BONUS_SALARY_SUCCESS'
export const REPORT_BONUS_SALARY_FAILED = 'REPORT_BONUS_SALARY_FAILED'
export const CLEAR_REPORT_BONUS_SALARY = 'CLEAR_REPORT_BONUS_SALARY'

export const FETCH_FEEDBACK_EMP_START = 'FETCH_FEEDBACK_EMP_START'
export const FETCH_FEEDBACK_EMP_SUCCESS = 'FETCH_FEEDBACK_EMP_SUCCESS'
export const FETCH_FEEDBACK_EMP_FAILED = 'FETCH_FEEDBACK_EMP_FAILED'

export const FETCH_FEEDBACK_STRUCTURE_START = 'FETCH_FEEDBACK_STRUCTURE_START'
export const FETCH_FEEDBACK_STRUCTURE_SUCCESS = 'FETCH_FEEDBACK_STRUCTURE_SUCCESS'
export const FETCH_FEEDBACK_STRUCTURE_FAILED = 'FETCH_FEEDBACK_STRUCTURE_FAILED'

export const FETCH_FEEDBACK_HISTORY_START = 'FETCH_FEEDBACK_HISTORY_START'
export const FETCH_FEEDBACK_HISTORY_SUCCESS = 'FETCH_FEEDBACK_HISTORY_SUCCESS'
export const FETCH_FEEDBACK_HISTORY_FAILED = 'FETCH_FEEDBACK_HISTORY_FAILED'

export const POST_FEEDBACK_HISTORY_START = 'POST_FEEDBACK_HISTORY_START'
export const POST_FEEDBACK_HISTORY_SUCCESS = 'POST_FEEDBACK_HISTORY_SUCCESS'
export const POST_FEEDBACK_HISTORY_FAILED = 'POST_FEEDBACK_HISTORY_FAILED'

export const SET_FEEDBACK_READ_STATE = 'SET_FEEDBACK_READ_STATE'

// Feedback report
export const FETCH_FEEDBACK_REPORT_DATA_START = 'FETCH_FEEDBACK_REPORT_DATA_START'
export const FETCH_FEEDBACK_REPORT_DATA_SUCCESS = 'FETCH_FEEDBACK_REPORT_DATA_SUCCESS'
export const FETCH_FEEDBACK_REPORT_DATA_FAILED = 'FETCH_FEEDBACK_REPORT_DATA_FAILED'

export const FETCH_LEVEL_TAGS_START = 'FETCH_LEVEL_TAGS_START'
export const FETCH_LEVEL_TAGS_SUCCESS = 'FETCH_LEVEL_TAGS_SUCCESS'
export const FETCH_LEVEL_TAGS_FAILED = 'FETCH_LEVEL_TAGS_FAILED'